webpackJsonp([1],{

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "08u2":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIwLjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IuODrOOCpOODpOODvF8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiCgkgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjYgMjAiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDI2IDIwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+Cgkuc3Qwe2ZpbGw6IzQxQjg4Mzt9Cgkuc3Qxe2ZpbGw6IzM1NDk1RTt9Cjwvc3R5bGU+CjxnPgoJPHBhdGggY2xhc3M9InN0MCIgZD0iTTIyLDJoLTMuNkwxMywxMUw3LjYsMkg0bDksMTVMMjIsMiIvPgo8L2c+CjxnPgoJPHBhdGggY2xhc3M9InN0MSIgZD0iTTE4LjQsMmgtMy4zTDEzLDUuNUwxMC45LDJINy42bDUuNCw5TDE4LjQsMiIvPgo8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "3gpg":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyMS4xLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0i44Os44Kk44Ok44O8XzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCINCgkgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjYgMjAiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDI2IDIwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8ZyBpZD0iWE1MSURfMjI2XyI+DQoJPGcgaWQ9IlhNTElEXzIzOF8iPg0KCQk8cGF0aCBpZD0iWE1MSURfMjM5XyIgZD0iTTIwLjEsMTQuMWMwLDAuMS0wLjQsMS4zLTEuMiwyLjVjLTAuNywxLjEtMS41LDIuMS0yLjcsMi4yYy0xLjIsMC0xLjUtMC43LTIuOS0wLjcNCgkJCWMtMS4zLDAtMS44LDAuNy0yLjksMC43Yy0xLjIsMC0yLTEuMi0yLjgtMi4yYy0xLjUtMi4yLTIuNy02LjEtMS4xLTguOGMwLjgtMS4zLDIuMS0yLjIsMy42LTIuMmMxLjEsMCwyLjIsMC44LDIuOSwwLjgNCgkJCWMwLjcsMCwyLTAuOSwzLjMtMC44YzAuNiwwLDIuMiwwLjIsMy4yLDEuN2MtMC4xLDAuMS0xLjksMS4xLTEuOSwzLjNDMTcuOCwxMy4yLDIwLjEsMTQuMSwyMC4xLDE0LjF6IE0xNS42LDQNCgkJCWMwLjYtMC43LDEtMS44LDAuOS0yLjhjLTAuOSwwLTEuOSwwLjYtMi42LDEuM2MtMC42LDAuNy0xLjEsMS43LTAuOSwyLjdDMTQsNS40LDE1LDQuOCwxNS42LDR6Ii8+DQoJPC9nPg0KPC9nPg0KPC9zdmc+DQo="

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "4QSR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "54sa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue-color/src/components/common/Saturation.vue
var Saturation = __webpack_require__("Er8W");
var Saturation_default = /*#__PURE__*/__webpack_require__.n(Saturation);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-736d40cb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-color/src/components/common/Saturation.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"vc-saturation",style:({background: _vm.bgColor}),on:{"mousedown":_vm.handleMouseDown}},[_c('div',{staticClass:"vc-saturation--white"}),_vm._v(" "),_c('div',{staticClass:"vc-saturation--black"}),_vm._v(" "),_c('div',{staticClass:"vc-saturation-pointer",style:({top: _vm.pointerTop, left: _vm.pointerLeft})},[_c('div',{staticClass:"vc-saturation-circle"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var common_Saturation = (esExports);
// CONCATENATED MODULE: ./node_modules/vue-color/src/components/common/Saturation.vue
function injectStyle (ssrContext) {
  __webpack_require__("wpRs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Saturation_default.a,
  common_Saturation,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_common_Saturation = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "5gQg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'Hue',
  props: {
    value: Object,
    direction: {
      type: String,

      default: 'horizontal'
    }
  },
  data: function data() {
    return {
      oldHue: 0,
      pullDirection: ''
    };
  },

  computed: {
    colors: function colors() {
      var h = this.value.hsl.h;
      if (h !== 0 && h - this.oldHue > 0) this.pullDirection = 'right';
      if (h !== 0 && h - this.oldHue < 0) this.pullDirection = 'left';
      this.oldHue = h;

      return this.value;
    },
    directionClass: function directionClass() {
      return {
        'vc-hue--horizontal': this.direction === 'horizontal',
        'vc-hue--vertical': this.direction === 'vertical'
      };
    },
    pointerTop: function pointerTop() {
      if (this.direction === 'vertical') {
        if (this.colors.hsl.h === 0 && this.pullDirection === 'right') return 0;
        return -(this.colors.hsl.h * 100 / 360) + 100 + '%';
      } else {
        return 0;
      }
    },
    pointerLeft: function pointerLeft() {
      if (this.direction === 'vertical') {
        return 0;
      } else {
        if (this.colors.hsl.h === 0 && this.pullDirection === 'right') return '100%';
        return this.colors.hsl.h * 100 / 360 + '%';
      }
    }
  },
  methods: {
    handleChange: function handleChange(e, skip) {
      !skip && e.preventDefault();

      var container = this.$refs.container;
      var containerWidth = container.clientWidth;
      var containerHeight = container.clientHeight;

      var xOffset = container.getBoundingClientRect().left + window.pageXOffset;
      var yOffset = container.getBoundingClientRect().top + window.pageYOffset;
      var pageX = e.pageX || (e.touches ? e.touches[0].pageX : 0);
      var pageY = e.pageY || (e.touches ? e.touches[0].pageY : 0);
      var left = pageX - xOffset;
      var top = pageY - yOffset;

      var h;
      var percent;

      if (this.direction === 'vertical') {
        if (top < 0) {
          h = 360;
        } else if (top > containerHeight) {
          h = 0;
        } else {
          percent = -(top * 100 / containerHeight) + 100;
          h = 360 * percent / 100;
        }

        if (this.colors.hsl.h !== h) {
          this.$emit('change', {
            h: h,
            s: this.colors.hsl.s,
            l: this.colors.hsl.l,
            a: this.colors.hsl.a,
            source: 'hsl'
          });
        }
      } else {
        if (left < 0) {
          h = 0;
        } else if (left > containerWidth) {
          h = 360;
        } else {
          percent = left * 100 / containerWidth;
          h = 360 * percent / 100;
        }

        if (this.colors.hsl.h !== h) {
          this.$emit('change', {
            h: h,
            s: this.colors.hsl.s,
            l: this.colors.hsl.l,
            a: this.colors.hsl.a,
            source: 'hsl'
          });
        }
      }
    },
    handleMouseDown: function handleMouseDown(e) {
      this.handleChange(e, true);
      window.addEventListener('mousemove', this.handleChange);
      window.addEventListener('mouseup', this.handleMouseUp);
    },
    handleMouseUp: function handleMouseUp(e) {
      this.unbindEventListeners();
    },
    unbindEventListeners: function unbindEventListeners() {
      window.removeEventListener('mousemove', this.handleChange);
      window.removeEventListener('mouseup', this.handleMouseUp);
    }
  }
};

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "6bUD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "78C+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "9Giv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


var _checkboardCache = {};

exports.default = {
  name: 'Checkboard',
  props: {
    size: {
      type: [Number, String],
      default: 8
    },
    white: {
      type: String,
      default: '#fff'
    },
    grey: {
      type: String,
      default: '#e6e6e6'
    }
  },
  computed: {
    bgStyle: function bgStyle() {
      return {
        'background-image': 'url(' + getCheckboard(this.white, this.grey, this.size) + ')'
      };
    }
  }
};


function renderCheckboard(c1, c2, size) {
  if (typeof document === 'undefined') {
    return null;
  }
  var canvas = document.createElement('canvas');
  canvas.width = canvas.height = size * 2;
  var ctx = canvas.getContext('2d');

  if (!ctx) {
    return null;
  }
  ctx.fillStyle = c1;
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.fillStyle = c2;
  ctx.fillRect(0, 0, size, size);
  ctx.translate(size, size);
  ctx.fillRect(0, 0, size, size);
  return canvas.toDataURL();
}

function getCheckboard(c1, c2, size) {
  var key = c1 + ',' + c2 + ',' + size;

  if (_checkboardCache[key]) {
    return _checkboardCache[key];
  } else {
    var checkboard = renderCheckboard(c1, c2, size);
    _checkboardCache[key] = checkboard;
    return checkboard;
  }
}

/***/ }),

/***/ "BuOL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "C9tR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CKXa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "D7tP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DCEM":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 1792 1792\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M1344 1344q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zm256 0q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zm128-224v320q0 40-28 68t-68 28h-1472q-40 0-68-28t-28-68v-320q0-40 28-68t68-28h465l135 136q58 56 136 56t136-56l136-136h464q40 0 68 28t28 68zm-325-569q17 41-14 70l-448 448q-18 19-45 19t-45-19l-448-448q-31-29-14-70 17-39 59-39h256v-448q0-26 19-45t45-19h256q26 0 45 19t19 45v448h256q42 0 59 39z\" fill=\"#fff\"></path></svg>"

/***/ }),

/***/ "DM9A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EPN0":
/***/ (function(module, exports) {

function webpackEmptyContext(req) {
	throw new Error("Cannot find module '" + req + "'.");
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
module.exports = webpackEmptyContext;
webpackEmptyContext.id = "EPN0";

/***/ }),

/***/ "Er8W":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__("R3sX");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Saturation',
  props: {
    value: Object
  },
  computed: {
    colors: function colors() {
      return this.value;
    },
    bgColor: function bgColor() {
      return 'hsl(' + this.colors.hsv.h + ', 100%, 50%)';
    },
    pointerTop: function pointerTop() {
      return -(this.colors.hsv.v * 100) + 1 + 100 + '%';
    },
    pointerLeft: function pointerLeft() {
      return this.colors.hsv.s * 100 + '%';
    }
  },
  methods: {
    throttle: (0, _lodash2.default)(function (fn, data) {
      fn(data);
    }, 20, {
      'leading': true,
      'trailing': false
    }),
    handleChange: function handleChange(e, skip) {
      !skip && e.preventDefault();
      var container = this.$refs.container;
      var containerWidth = container.clientWidth;
      var containerHeight = container.clientHeight;

      var xOffset = container.getBoundingClientRect().left + window.pageXOffset;
      var yOffset = container.getBoundingClientRect().top + window.pageYOffset;
      var pageX = e.pageX || (e.touches ? e.touches[0].pageX : 0);
      var pageY = e.pageY || (e.touches ? e.touches[0].pageY : 0);
      var left = pageX - xOffset;
      var top = pageY - yOffset;

      if (left < 0) {
        left = 0;
      } else if (left > containerWidth) {
        left = containerWidth;
      } else if (top < 0) {
        top = 0;
      } else if (top > containerHeight) {
        top = containerHeight;
      }

      var saturation = left / containerWidth;
      var bright = -(top / containerHeight) + 1;

      bright = bright > 0 ? bright : 0;
      bright = bright > 1 ? 1 : bright;

      this.throttle(this.onChange, {
        h: this.colors.hsv.h,
        s: saturation,
        v: bright,
        a: this.colors.hsv.a,
        source: 'hsva'
      });
    },
    onChange: function onChange(param) {
      this.$emit('change', param);
    },
    handleMouseDown: function handleMouseDown(e) {
      window.addEventListener('mousemove', this.handleChange);
      window.addEventListener('mouseup', this.handleChange);
      window.addEventListener('mouseup', this.handleMouseUp);
    },
    handleMouseUp: function handleMouseUp(e) {
      this.unbindEventListeners();
    },
    unbindEventListeners: function unbindEventListeners() {
      window.removeEventListener('mousemove', this.handleChange);
      window.removeEventListener('mouseup', this.handleChange);
      window.removeEventListener('mouseup', this.handleMouseUp);
    }
  }
};

/***/ }),

/***/ "FuAV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FwR8":
/***/ (function(module, exports) {

module.exports = [{"prop":"animation","initial":"${animation-name} ${animation-duration} ${animation-timing-function} ${animation-delay} ${animation-iteration-count} ${animation-direction} ${animation-fill-mode} ${animation-play-state}","combined":true},{"prop":"animation-delay","initial":"0s"},{"prop":"animation-direction","initial":"normal"},{"prop":"animation-duration","initial":"0s"},{"prop":"animation-fill-mode","initial":"none"},{"prop":"animation-iteration-count","initial":"1"},{"prop":"animation-name","initial":"none"},{"prop":"animation-play-state","initial":"running"},{"prop":"animation-timing-function","initial":"ease"},{"prop":"backface-visibility","initial":"visible","basic":true},{"prop":"background","initial":"${background-color} ${background-image} ${background-repeat} ${background-position} / ${background-size} ${background-origin} ${background-clip} ${background-attachment}","combined":true},{"prop":"background-attachment","initial":"scroll"},{"prop":"background-clip","initial":"border-box"},{"prop":"background-color","initial":"transparent"},{"prop":"background-image","initial":"none"},{"prop":"background-origin","initial":"padding-box"},{"prop":"background-position","initial":"0 0"},{"prop":"background-position-x","initial":"0"},{"prop":"background-position-y","initial":"0"},{"prop":"background-repeat","initial":"repeat"},{"prop":"background-size","initial":"auto auto"},{"prop":"border","initial":"${border-width} ${border-style} ${border-color}","combined":true},{"prop":"border-style","initial":"none"},{"prop":"border-width","initial":"medium"},{"prop":"border-color","initial":"currentColor"},{"prop":"border-bottom","initial":"0"},{"prop":"border-bottom-color","initial":"currentColor"},{"prop":"border-bottom-left-radius","initial":"0"},{"prop":"border-bottom-right-radius","initial":"0"},{"prop":"border-bottom-style","initial":"none"},{"prop":"border-bottom-width","initial":"medium"},{"prop":"border-collapse","initial":"separate","basic":true,"inherited":true},{"prop":"border-image","initial":"none","basic":true},{"prop":"border-left","initial":"0"},{"prop":"border-left-color","initial":"currentColor"},{"prop":"border-left-style","initial":"none"},{"prop":"border-left-width","initial":"medium"},{"prop":"border-radius","initial":"0","basic":true},{"prop":"border-right","initial":"0"},{"prop":"border-right-color","initial":"currentColor"},{"prop":"border-right-style","initial":"none"},{"prop":"border-right-width","initial":"medium"},{"prop":"border-spacing","initial":"0","basic":true,"inherited":true},{"prop":"border-top","initial":"0"},{"prop":"border-top-color","initial":"currentColor"},{"prop":"border-top-left-radius","initial":"0"},{"prop":"border-top-right-radius","initial":"0"},{"prop":"border-top-style","initial":"none"},{"prop":"border-top-width","initial":"medium"},{"prop":"bottom","initial":"auto","basic":true},{"prop":"box-shadow","initial":"none","basic":true},{"prop":"box-sizing","initial":"content-box","basic":true},{"prop":"caption-side","initial":"top","basic":true,"inherited":true},{"prop":"clear","initial":"none","basic":true},{"prop":"clip","initial":"auto","basic":true},{"prop":"color","initial":"#000","basic":true},{"prop":"columns","initial":"auto","basic":true},{"prop":"column-count","initial":"auto","basic":true},{"prop":"column-fill","initial":"balance","basic":true},{"prop":"column-gap","initial":"normal","basic":true},{"prop":"column-rule","initial":"${column-rule-width} ${column-rule-style} ${column-rule-color}","combined":true},{"prop":"column-rule-color","initial":"currentColor"},{"prop":"column-rule-style","initial":"none"},{"prop":"column-rule-width","initial":"medium"},{"prop":"column-span","initial":"1","basic":true},{"prop":"column-width","initial":"auto","basic":true},{"prop":"content","initial":"normal","basic":true},{"prop":"counter-increment","initial":"none","basic":true},{"prop":"counter-reset","initial":"none","basic":true},{"prop":"cursor","initial":"auto","basic":true,"inherited":true},{"prop":"direction","initial":"ltr","basic":true,"inherited":true},{"prop":"display","initial":"inline","basic":true},{"prop":"empty-cells","initial":"show","basic":true,"inherited":true},{"prop":"float","initial":"none","basic":true},{"prop":"font","contains":["font-style","font-variant","font-weight","font-stretch","font-size","line-height","font-family"],"basic":true,"inherited":true},{"prop":"font-family","initial":"serif"},{"prop":"font-size","initial":"medium"},{"prop":"font-style","initial":"normal"},{"prop":"font-variant","initial":"normal"},{"prop":"font-weight","initial":"normal"},{"prop":"font-stretch","initial":"normal"},{"prop":"line-height","initial":"normal","inherited":true},{"prop":"height","initial":"auto","basic":true},{"prop":"hyphens","initial":"none","basic":true,"inherited":true},{"prop":"left","initial":"auto","basic":true},{"prop":"letter-spacing","initial":"normal","basic":true,"inherited":true},{"prop":"list-style","initial":"${list-style-type} ${list-style-position} ${list-style-image}","combined":true,"inherited":true},{"prop":"list-style-image","initial":"none"},{"prop":"list-style-position","initial":"outside"},{"prop":"list-style-type","initial":"disc"},{"prop":"margin","initial":"0","basic":true},{"prop":"margin-bottom","initial":"0"},{"prop":"margin-left","initial":"0"},{"prop":"margin-right","initial":"0"},{"prop":"margin-top","initial":"0"},{"prop":"max-height","initial":"none","basic":true},{"prop":"max-width","initial":"none","basic":true},{"prop":"min-height","initial":"0","basic":true},{"prop":"min-width","initial":"0","basic":true},{"prop":"opacity","initial":"1","basic":true},{"prop":"orphans","initial":"2","basic":true},{"prop":"outline","initial":"${outline-width} ${outline-style} ${outline-color}","combined":true},{"prop":"outline-color","initial":"invert"},{"prop":"outline-style","initial":"none"},{"prop":"outline-width","initial":"medium"},{"prop":"overflow","initial":"visible","basic":true},{"prop":"overflow-x","initial":"visible","basic":true},{"prop":"overflow-y","initial":"visible","basic":true},{"prop":"padding","initial":"0","basic":true},{"prop":"padding-bottom","initial":"0"},{"prop":"padding-left","initial":"0"},{"prop":"padding-right","initial":"0"},{"prop":"padding-top","initial":"0"},{"prop":"page-break-after","initial":"auto","basic":true},{"prop":"page-break-before","initial":"auto","basic":true},{"prop":"page-break-inside","initial":"auto","basic":true},{"prop":"perspective","initial":"none","basic":true},{"prop":"perspective-origin","initial":"50% 50%","basic":true},{"prop":"position","initial":"static","basic":true},{"prop":"quotes","initial":"“ ” ‘ ’"},{"prop":"right","initial":"auto","basic":true},{"prop":"tab-size","initial":"8","basic":true,"inherited":true},{"prop":"table-layout","initial":"auto","basic":true},{"prop":"text-align","initial":"left","basic":true,"inherited":true},{"prop":"text-align-last","initial":"auto","basic":true,"inherited":true},{"prop":"text-decoration","initial":"${text-decoration-line}","combined":true},{"prop":"text-decoration-color","initial":"inherited"},{"prop":"text-decoration-color","initial":"currentColor"},{"prop":"text-decoration-line","initial":"none"},{"prop":"text-decoration-style","initial":"solid"},{"prop":"text-indent","initial":"0","basic":true,"inherited":true},{"prop":"text-shadow","initial":"none","basic":true,"inherited":true},{"prop":"text-transform","initial":"none","basic":true,"inherited":true},{"prop":"top","initial":"auto","basic":true},{"prop":"transform","initial":"none","basic":true},{"prop":"transform-origin","initial":"50% 50% 0","basic":true},{"prop":"transform-style","initial":"flat","basic":true},{"prop":"transition","initial":"${transition-property} ${transition-duration} ${transition-timing-function} ${transition-delay}","combined":true},{"prop":"transition-delay","initial":"0s"},{"prop":"transition-duration","initial":"0s"},{"prop":"transition-property","initial":"none"},{"prop":"transition-timing-function","initial":"ease"},{"prop":"unicode-bidi","initial":"normal","basic":true},{"prop":"vertical-align","initial":"baseline","basic":true},{"prop":"visibility","initial":"visible","basic":true,"inherited":true},{"prop":"white-space","initial":"normal","basic":true,"inherited":true},{"prop":"widows","initial":"2","basic":true,"inherited":true},{"prop":"width","initial":"auto","basic":true},{"prop":"word-spacing","initial":"normal","basic":true,"inherited":true},{"prop":"z-index","initial":"auto","basic":true}]

/***/ }),

/***/ "HGpZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _postcss = __webpack_require__("Y7In");

var _postcss2 = _interopRequireDefault(_postcss);

var _postcssValueParser = __webpack_require__("3Glt");

var _postcssValueParser2 = _interopRequireDefault(_postcssValueParser);

var _lodash = __webpack_require__("M4fF");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fontFamilySystemUIList = ['system-ui', '-apple-system', 'BlinkMacSystemFont', 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue'];

var parsedFontFamilySystemUIListTree = (0, _postcssValueParser2.default)(fontFamilySystemUIList.join(', '));

var transformFontFamilySystemUI = function transformFontFamilySystemUI(nodes) {
  return (0, _lodash.flatMap)(nodes, function (node) {
    if (node.type === 'word' && node.value === 'system-ui') {
      return parsedFontFamilySystemUIListTree;
    }
    return node;
  });
};

var transform = function transform() {
  return function (decl) {
    if (decl.type === 'decl') {
      if (decl.prop === 'font-family' || decl.prop === 'font') {
        var tree = (0, _postcssValueParser2.default)(decl.value);
        tree.nodes = transformFontFamilySystemUI(tree.nodes);
        decl.value = tree.toString();
      }
    }
  };
};

exports.default = _postcss2.default.plugin('postcss-font-family-system-ui', function () {
  return function (root) {
    root.walk(transform());
  };
});

/***/ }),

/***/ "Hvol":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IIii":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/portal-vue/dist/portal-vue.js
var portal_vue = __webpack_require__("9mpg");
var portal_vue_default = /*#__PURE__*/__webpack_require__.n(portal_vue);

// EXTERNAL MODULE: ./node_modules/vue-js-modal/dist/index.js
var dist = __webpack_require__("rifk");
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);

// EXTERNAL MODULE: ./node_modules/vue-js-popover/dist/index.js
var vue_js_popover_dist = __webpack_require__("JwGB");
var vue_js_popover_dist_default = /*#__PURE__*/__webpack_require__.n(vue_js_popover_dist);

// EXTERNAL MODULE: ./node_modules/vue-i18n/dist/vue-i18n.esm.js
var vue_i18n_esm = __webpack_require__("TXmL");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/slicedToArray.js
var slicedToArray = __webpack_require__("d7EF");
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// CONCATENATED MODULE: ./src/store/index.js






vue_esm["default"].use(vuex_esm["a" /* default */]);

var stateLike = {
  browserslist: [],
  cssComponents: [],
  customVars: {},
  fullComponentsIndex: '',
  loading: false,
  rootCSS: '',
  selectedCategory: '',
  selectedPlatform: 'All',
  showCustomizer: false,
  theme: '',
  customTheme: '',
  themes: [],
  version: '',
  versionIndex: 0,
  versions: [],
  extraExamples: []
};

var store_createMutations = function createMutations() {
  return keys_default()(stateLike).reduce(function (mutations, key) {
    return extends_default()({}, mutations, defineProperty_default()({}, key, function (state, payload) {
      state[key] = payload;
    }));
  }, {});
};

var store = new vuex_esm["a" /* default */].Store({
  state: extends_default()({}, stateLike),
  mutations: store_createMutations(),
  getters: {
    categories: function categories(state) {
      return state.cssComponents.map(function (c) {
        return c.annotation;
      }).concat(state.extraExamples).map(function (a) {
        return a.category;
      }).sort().filter(function (el, i, arr) {
        return el !== arr[i - 1];
      });
    }
  }
});

var store_mapMutationState = function mapMutationState(states) {
  return states.reduce(function (computed, key) {
    return extends_default()({}, computed, defineProperty_default()({}, key, {
      get: function get() {
        return store.state[key];
      },
      set: function set(value) {
        store.commit(key, value);
      }
    }));
  }, {});
};

/* harmony default export */ var src_store = (store);
// EXTERNAL MODULE: ./node_modules/@onsenui/ancss/index.js
var ancss = __webpack_require__("TAnT");
var ancss_default = /*#__PURE__*/__webpack_require__.n(ancss);

// EXTERNAL MODULE: ./node_modules/postcss/lib/postcss.js
var postcss = __webpack_require__("Y7In");
var postcss_default = /*#__PURE__*/__webpack_require__.n(postcss);

// EXTERNAL MODULE: ./node_modules/postcss-cssnext/lib/index.js
var lib = __webpack_require__("9YLo");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./node_modules/postcss-url-resolver/src/index.js
var src = __webpack_require__("Y+s+");
var src_default = /*#__PURE__*/__webpack_require__.n(src);

// EXTERNAL MODULE: ./node_modules/clean-css/index.js
var clean_css = __webpack_require__("9cA8");
var clean_css_default = /*#__PURE__*/__webpack_require__.n(clean_css);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("Gu7T");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/classCallCheck.js
var classCallCheck = __webpack_require__("Zrlr");
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/createClass.js
var createClass = __webpack_require__("wxAW");
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass);

// CONCATENATED MODULE: ./src/api/cache.js



var cache_Cache = function () {
  function Cache() {
    classCallCheck_default()(this, Cache);

    this.cache = {};
  }

  createClass_default()(Cache, [{
    key: "has",
    value: function has(id) {
      return Object.hasOwnProperty.call(this.cache, id) || window.localStorage.getItem(id) !== null;
    }
  }, {
    key: "get",
    value: function get(id) {
      return this.cache[id] || window.localStorage.getItem(id);
    }
  }, {
    key: "set",
    value: function set(id, value) {
      var persist = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (persist) {
        window.localStorage.setItem(id, value);
      } else {
        this.cache[id] = value;
      }
      return value;
    }
  }, {
    key: "remove",
    value: function remove(id) {
      window.localStorage.removeItem(id);
      delete this.cache[id];
    }
  }]);

  return Cache;
}();

/* harmony default export */ var cache = (new cache_Cache());
// CONCATENATED MODULE: ./src/api/request.js




axios_default.a.interceptors.response.use(undefined, function (error) {
  // Unpkg sometimes does not have files cached
  if (error.response && error.response.status === 404 && error.config && !error.config.isRetry) {
    error.config.isRetry = true;
    console.info('HTTP error - Retrying after 3 seconds.'); // eslint-disable-line
    return new promise_default.a(function (resolve) {
      return setTimeout(function () {
        return resolve(axios_default()(error.config));
      }, 3000);
    });
  }

  return promise_default.a.reject(error);
});

function request_request(uri) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$filter = _ref.filter,
      filter = _ref$filter === undefined ? function (res) {
    return res;
  } : _ref$filter,
      _ref$headers = _ref.headers,
      headers = _ref$headers === undefined ? { 'Content-Type': 'application/json' } : _ref$headers;

  if (cache.has(uri)) {
    return promise_default.a.resolve(cache.get(uri));
  }

  return axios_default.a.get(uri, { headers: headers }).then(function (res) {
    return cache.set(uri, filter(res.data));
  });
}
// CONCATENATED MODULE: ./src/util.js
/* harmony default export */ var util = ({
  toLabel: function toLabel(string) {
    return string.replace(/-/g, ' ').toLowerCase().replace('color', '').trim();
  },

  toId: function toId(string) {
    return string.replace(/\s+/, '-').toLowerCase();
  },

  capitalize: function capitalize(string) {
    return string.replace(/^([a-z])/, function (m) {
      return m.toUpperCase();
    });
  },

  capitalizeAll: function capitalizeAll(string) {
    return string.replace(/(^|\s)([a-z])/g, function (m) {
      return m.toUpperCase();
    });
  }

});
// CONCATENATED MODULE: ./src/api/index.js




var cdn = 'https://unpkg.com/onsenui';
var repo = 'https://api.github.com/repos/OnsenUI/OnsenUI-dist/';

/* harmony default export */ var api = ({
  get: request_request,

  urls: {
    cssComponents: function cssComponents(version) {
      return cdn + '@' + version + '/css-components-src/src/onsen-css-components.css';
    },
    componentsIndex: function componentsIndex(version) {
      return cdn + '@' + version + '/css-components-src/src/components/index.css';
    }
  },

  getThemeCSS: function getThemeCSS(version, name) {
    var url = cdn + '@' + version + '/css-components-src/src/' + name;
    var headers = { 'Content-Type': 'text/css' };

    return request_request(url, { headers: headers });
  },
  getComponentsIndex: function getComponentsIndex(version) {
    var url = this.urls.componentsIndex(version);
    var headers = { 'Content-Type': 'text/css' };

    return request_request(url, { headers: headers });
  },
  getVersions: function getVersions() {
    var url = repo + 'releases';
    var filter = function filter(items) {
      return items
      // split version string into [major, minor, patch] array
      .map(function (i) {
        return i.tag_name.split('.', 3).map(function (x) {
          return parseInt(x, 10);
        });
      }).filter(function (version) {
        // true iff version is >= 2.6.0
        var minimum = [2, 6, 0];
        return version.length === 3 && (version[0] > minimum[0] || version[0] === minimum[0] && version[1] >= minimum[1]);
      })
      // sort by newest version first
      .sort(function (a, b) {
        for (var i = 0; i < 3; i++) {
          if (a[i] < b[i]) {
            return 1;
          } else if (a[i] > b[i]) {
            return -1;
          }
        }
        return 0; // versions are equal
      })
      // concat version arrays back into version strings
      .map(function (version) {
        return version.join('.');
      });
    };

    return request_request(url, { filter: filter });
  },
  getThemes: function getThemes(version) {
    var url = repo + 'contents/css-components-src/src?ref=' + version;
    var filter = function filter(items) {
      return items.filter(function (i) {
        return (/theme.css$/.test(i.name) && !/custom-theme.css$/.test(i.name)
        );
      }) // Fix for v2.8.2
      .reduce(function (result, theme) {
        return [].concat(toConsumableArray_default()(result), [{
          theme: theme,
          label: theme.name === 'theme.css' ? 'Default' : util.capitalize(util.toLabel(theme.name.split('.')[0]))
        }]);
      }, []).sort(function (a, b) {
        return a.theme.name.length > b.theme.name.length;
      });
    };

    return request_request(url, { filter: filter });
  },
  getBrowserslist: function getBrowserslist() {
    // Use latest always
    var url = cdn + '/package.json';
    var filter = function filter(pkg) {
      return pkg.browserslist;
    };

    return request_request(url, { filter: filter });
  }
});
// CONCATENATED MODULE: ./src/css-processor.js








var css_processor_delay = function delay(fn) {
  return new promise_default.a(function (resolve) {
    return setTimeout(function () {
      return resolve(fn());
    }, 300);
  });
};

var css_processor_run = function run() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$from = _ref.from,
      from = _ref$from === undefined ? '' : _ref$from,
      _ref$base = _ref.base64,
      base64 = _ref$base === undefined ? false : _ref$base,
      _ref$exclude = _ref.exclude,
      exclude = _ref$exclude === undefined ? null : _ref$exclude,
      _ref$css = _ref.css,
      css = _ref$css === undefined ? '@import url(\'' + from + '\');' : _ref$css,
      _ref$cssnext = _ref.cssnext,
      cssnext = _ref$cssnext === undefined ? false : _ref$cssnext;

  var plugins = [];

  if (from) {
    plugins.push(src_default()({
      request: function request(opt) {
        return api.get(opt.href);
      },
      base64: base64,
      exclude: exclude
    }));
  }

  if (cssnext) {
    plugins.push(lib_default()(cssnext));
  }

  // Postcss is synchronous...
  return css_processor_delay(function () {
    return postcss_default()(plugins).process(css, { from: from }).then(function (result) {
      return result.css;
    });
  });
};

/* harmony default export */ var css_processor = ({
  get: function get(from) {
    return css_processor_run({
      from: from,
      base64: true,
      exclude: /(theme|components\/index).css$/
    });
  },
  compile: function compile(css) {
    return css_processor_run({
      css: css,
      base64: true,
      cssnext: {
        browsers: src_store.state.browserslist,
        features: {
          customProperties: {
            variables: src_store.state.customVars
          }
        }
      },
      from: api.urls.componentsIndex(src_store.state.version)
    });
  },
  compileVariables: function compileVariables(css) {
    return css_processor_run({
      css: css,
      cssnext: {
        features: {
          customProperties: {
            preserve: 'computed'
          }
        }
      }
    });
  },
  replace: function replace(css, theme, index) {
    return css.replace(/^(\s*@import.+theme\.css.+\n)/m, theme).replace(/^(\s*@import.+components\/index\.css.+)$/m, index);
  },
  minify: function minify(css) {
    return css_processor_delay(function () {
      return new clean_css_default.a().minify(css).styles;
    });
  }
});
// EXTERNAL MODULE: ./src/assets/inline/pencil.svg
var pencil = __webpack_require__("zkob");
var pencil_default = /*#__PURE__*/__webpack_require__.n(pencil);

// EXTERNAL MODULE: ./src/assets/inline/download.svg
var download = __webpack_require__("DCEM");
var download_default = /*#__PURE__*/__webpack_require__.n(download);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/TRButton.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var TRButton = ({
  name: 'TRButton',

  props: {
    label: {
      type: String,
      default: 'Empty'
    },
    icon: {
      type: String,
      default: ''
    },
    inverted: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      icons: {
        pencil: pencil_default.a,
        download: download_default.a
      }
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-da168f00","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TRButton.vue
var TRButton_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',_vm._g({staticClass:"tr-button",class:{ inverted: _vm.inverted, loader: _vm.loading }},_vm.$listeners),[_c('div',{style:({ opacity: Number(!_vm.loading) })},[(_vm.icon && _vm.icons[_vm.icon])?_c('i',{staticClass:"tr-button__icon",class:_vm.icon,domProps:{"innerHTML":_vm._s(_vm.icons[_vm.icon])}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"tr-button__label"},[_vm._t("default",[_vm._v(_vm._s(_vm.label))])],2)])])}
var staticRenderFns = []
var esExports = { render: TRButton_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_TRButton = (esExports);
// CONCATENATED MODULE: ./src/components/TRButton.vue
function injectStyle (ssrContext) {
  __webpack_require__("sBxa")
  __webpack_require__("CKXa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-da168f00"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  TRButton,
  components_TRButton,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_TRButton = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/TRCloseButton.vue
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var TRCloseButton = ({
  name: 'TRCloseButton'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d1324596","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TRCloseButton.vue
var TRCloseButton_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',_vm._g({staticClass:"tr-close-button"},_vm.$listeners),[_c('span'),_vm._v(" "),_c('span')])}
var TRCloseButton_staticRenderFns = []
var TRCloseButton_esExports = { render: TRCloseButton_render, staticRenderFns: TRCloseButton_staticRenderFns }
/* harmony default export */ var components_TRCloseButton = (TRCloseButton_esExports);
// CONCATENATED MODULE: ./src/components/TRCloseButton.vue
function TRCloseButton_injectStyle (ssrContext) {
  __webpack_require__("Hvol")
}
var TRCloseButton_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var TRCloseButton___vue_template_functional__ = false
/* styles */
var TRCloseButton___vue_styles__ = TRCloseButton_injectStyle
/* scopeId */
var TRCloseButton___vue_scopeId__ = "data-v-d1324596"
/* moduleIdentifier (server only) */
var TRCloseButton___vue_module_identifier__ = null
var TRCloseButton_Component = TRCloseButton_normalizeComponent(
  TRCloseButton,
  components_TRCloseButton,
  TRCloseButton___vue_template_functional__,
  TRCloseButton___vue_styles__,
  TRCloseButton___vue_scopeId__,
  TRCloseButton___vue_module_identifier__
)

/* harmony default export */ var src_components_TRCloseButton = (TRCloseButton_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue-color/src/components/Chrome.vue
var Chrome = __webpack_require__("oFtk");
var Chrome_default = /*#__PURE__*/__webpack_require__.n(Chrome);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-076d1d10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-color/src/components/Chrome.vue
var Chrome_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['vc-chrome', _vm.disableAlpha ? 'vc-chrome__disable-alpha' : '']},[_c('div',{staticClass:"vc-chrome-saturation-wrap"},[_c('saturation',{on:{"change":_vm.childChange},model:{value:(_vm.colors),callback:function ($$v) {_vm.colors=$$v},expression:"colors"}})],1),_vm._v(" "),_c('div',{staticClass:"vc-chrome-body"},[_c('div',{staticClass:"vc-chrome-controls"},[_c('div',{staticClass:"vc-chrome-color-wrap"},[_c('div',{staticClass:"vc-chrome-active-color",style:({background: _vm.activeColor})}),_vm._v(" "),(!_vm.disableAlpha)?_c('checkboard'):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"vc-chrome-sliders"},[_c('div',{staticClass:"vc-chrome-hue-wrap"},[_c('hue',{on:{"change":_vm.childChange},model:{value:(_vm.colors),callback:function ($$v) {_vm.colors=$$v},expression:"colors"}})],1),_vm._v(" "),(!_vm.disableAlpha)?_c('div',{staticClass:"vc-chrome-alpha-wrap"},[_c('alpha',{on:{"change":_vm.childChange},model:{value:(_vm.colors),callback:function ($$v) {_vm.colors=$$v},expression:"colors"}})],1):_vm._e()])]),_vm._v(" "),(!_vm.disableFields)?_c('div',{staticClass:"vc-chrome-fields-wrap"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.fieldsIndex === 0),expression:"fieldsIndex === 0"}],staticClass:"vc-chrome-fields"},[_c('div',{staticClass:"vc-chrome-field"},[_c('ed-in',{attrs:{"label":"hex","value":_vm.colors.hex},on:{"change":_vm.inputChange}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.fieldsIndex === 1),expression:"fieldsIndex === 1"}],staticClass:"vc-chrome-fields"},[_c('div',{staticClass:"vc-chrome-field"},[_c('ed-in',{attrs:{"label":"r","value":_vm.colors.rgba.r},on:{"change":_vm.inputChange}})],1),_vm._v(" "),_c('div',{staticClass:"vc-chrome-field"},[_c('ed-in',{attrs:{"label":"g","value":_vm.colors.rgba.g},on:{"change":_vm.inputChange}})],1),_vm._v(" "),_c('div',{staticClass:"vc-chrome-field"},[_c('ed-in',{attrs:{"label":"b","value":_vm.colors.rgba.b},on:{"change":_vm.inputChange}})],1),_vm._v(" "),(!_vm.disableAlpha)?_c('div',{staticClass:"vc-chrome-field"},[_c('ed-in',{attrs:{"label":"a","value":_vm.colors.a,"arrow-offset":0.01,"max":1},on:{"change":_vm.inputChange}})],1):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.fieldsIndex === 2),expression:"fieldsIndex === 2"}],staticClass:"vc-chrome-fields"},[_c('div',{staticClass:"vc-chrome-field"},[_c('ed-in',{attrs:{"label":"h","value":_vm.hsl.h},on:{"change":_vm.inputChange}})],1),_vm._v(" "),_c('div',{staticClass:"vc-chrome-field"},[_c('ed-in',{attrs:{"label":"s","value":_vm.hsl.s},on:{"change":_vm.inputChange}})],1),_vm._v(" "),_c('div',{staticClass:"vc-chrome-field"},[_c('ed-in',{attrs:{"label":"l","value":_vm.hsl.l},on:{"change":_vm.inputChange}})],1),_vm._v(" "),(!_vm.disableAlpha)?_c('div',{staticClass:"vc-chrome-field"},[_c('ed-in',{attrs:{"label":"a","value":_vm.colors.a,"arrow-offset":0.01,"max":1},on:{"change":_vm.inputChange}})],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"vc-chrome-toggle-btn",on:{"click":_vm.toggleViews}},[_c('div',{staticClass:"vc-chrome-toggle-icon"},[_c('svg',{staticStyle:{"width":"24px","height":"24px"},attrs:{"viewBox":"0 0 24 24"},on:{"mouseover":_vm.showHighlight,"mouseenter":_vm.showHighlight,"mouseout":_vm.hideHighlight}},[_c('path',{attrs:{"fill":"#333","d":"M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z"}})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.highlight),expression:"highlight"}],staticClass:"vc-chrome-toggle-icon-highlight"})])]):_vm._e()])])}
var Chrome_staticRenderFns = []
var Chrome_esExports = { render: Chrome_render, staticRenderFns: Chrome_staticRenderFns }
/* harmony default export */ var components_Chrome = (Chrome_esExports);
// CONCATENATED MODULE: ./node_modules/vue-color/src/components/Chrome.vue
function Chrome_injectStyle (ssrContext) {
  __webpack_require__("FuAV")
}
var Chrome_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Chrome___vue_template_functional__ = false
/* styles */
var Chrome___vue_styles__ = Chrome_injectStyle
/* scopeId */
var Chrome___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Chrome___vue_module_identifier__ = null
var Chrome_Component = Chrome_normalizeComponent(
  Chrome_default.a,
  components_Chrome,
  Chrome___vue_template_functional__,
  Chrome___vue_styles__,
  Chrome___vue_scopeId__,
  Chrome___vue_module_identifier__
)

/* harmony default export */ var src_components_Chrome = (Chrome_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/TRCustomizer.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var get = function get(re, s) {
  return re.exec(s)[1].trim();
};
var reKey = /(--[-\w]+)\s*:/;
var reVal = /:(.*);\n/;

var TRCustomizer_themeToVars = function themeToVars() {
  var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return (string.match(/\s*--([-\w]+):\s+(.*);\n/img) || []).reduce(function (result, variable) {
    return extends_default()(defineProperty_default()({}, get(reKey, variable), get(reVal, variable)), result);
  }, {});
};

/* harmony default export */ var TRCustomizer = ({
  name: 'TRCustomizer',
  components: {
    colorPicker: src_components_Chrome,
    TRButton: src_components_TRButton,
    TRCloseButton: src_components_TRCloseButton
  },

  filters: {
    toLabel: function toLabel(string) {
      return util.toLabel(string).replace('material', 'MD');
    }
  },

  data: function data() {
    return {
      bulkContent: '',
      compiledCustomVars: {},
      compiledCustomTheme: '',
      compiledTheme: '',
      componentsVars: [],
      commonVars: [],
      currentVar: '',
      colors: '#fff'
    };
  },


  computed: extends_default()({}, store_mapMutationState(['customTheme', 'customVars', 'loading', 'selectedCategory', 'selectedPlatform', 'showCustomizer', 'theme', 'version']), {

    // Fix for a wrong Onsen UI CSS variable in <= 2.8.2
    fixedTheme: function fixedTheme() {
      return this.theme.replace('var(--input-border-color)', 'var(--border-color)');
    },


    // Uncompiled preset variables
    originalVars: function originalVars() {
      return this.fixedTheme ? TRCustomizer_themeToVars(this.fixedTheme) : {};
    },


    // Show colors in squared preview
    compiledOriginalVars: function compiledOriginalVars() {
      return this.compiledTheme ? TRCustomizer_themeToVars(this.compiledTheme) : {};
    },


    // Prerequisite for filtering variables by category
    categories: function categories() {
      return this.$store.getters.categories.map(function (c) {
        return c.toLowerCase().replace('search input', 'search').replace('select input', 'select').trim().replace(/\s+/, '-');
      });
    },


    // Filter step 1: categories
    categoryFilteredVars: function categoryFilteredVars() {
      var category = this.selectedCategory.trim().toLowerCase().replace(/\s+/, '-');

      // Fix: search-input and select-input variables
      if (category.indexOf('-input') !== -1 && category !== 'text-input') {
        var _category$split = category.split('-');

        var _category$split2 = slicedToArray_default()(_category$split, 1);

        category = _category$split2[0];
      }

      var categorySet = [category];

      // Fix: add button-bar to segment category
      if (category === 'segment') {
        categorySet.push('button-bar');
      }

      return this.componentsVars.filter(function (v) {
        return categorySet.some(function (c) {
          return v.indexOf('--' + c) !== -1 || v.indexOf('--material-' + c) !== -1;
        });
      });
    },


    // Filter step 2: platform
    filteredVars: function filteredVars() {
      var _this = this;

      return this.selectedPlatform === 'All' ? this.categoryFilteredVars : this.categoryFilteredVars.filter(function (v) {
        var md = v.indexOf('material') !== -1;
        return md && _this.selectedPlatform === 'Android' || !md && _this.selectedPlatform === 'iOS';
      });
    },


    // Filter step 3: combine variables
    visibleVars: function visibleVars() {
      return this.commonVars.concat(this.filteredVars);
    }
  }),

  watch: {
    // Split unfilterable and filterable variables
    compiledOriginalVars: function compiledOriginalVars() {
      this.splitVars();
    },
    categories: function categories() {
      this.splitVars();
    },


    // Selected variable showing color picker
    currentVar: function currentVar(variable) {
      this.colors = this.compiledCustomVars[variable] || this.compiledOriginalVars[variable] || '';
    },


    // On theme preset change, compile and update
    theme: {
      immediate: true,
      handler: function handler() {
        var _this2 = this;

        // Custom theme
        var theme = this.fixedTheme;
        keys_default()(this.customVars).forEach(function (v) {
          var re = new RegExp(v + '\\s*:.*;\\n', 'img');
          theme = theme.replace(re, v + ': ' + _this2.customVars[v] + ';\n');
        });

        this.customTheme = theme;
        this.bulkContent = theme;

        // Preset theme
        css_processor.compileVariables(this.fixedTheme).then(function (compiledTheme) {
          _this2.compiledTheme = compiledTheme;
        });
      }
    }
  },

  created: function created() {
    this.bulkContent = cache.get('bulk-content') || '';
    if (this.bulkContent !== '') {
      this.$log('Found a custom theme cached.');
      this.saveBulk();
    }
  },


  methods: {
    splitVars: function splitVars() {
      var _this3 = this;

      if (keys_default()(this.compiledOriginalVars).length === 0 || this.categories.length === 0) {
        return; // Initial perf
      }

      var common = [];
      var other = [];

      keys_default()(this.compiledOriginalVars).forEach(function (v) {
        var isShared = !_this3.categories.some(function (c) {
          return v.indexOf(c.toLowerCase()) !== -1;
        });

        (isShared ? common : other).push(v);
      });

      var sort = function sort(arr) {
        var raw = function raw(v) {
          return (/material-/.test(v) ? v.replace('material-', '') + '-' : v
          );
        };

        return arr.map(function (v) {
          return [v, raw(v)];
        }).sort(function (a, b) {
          return a[1].localeCompare(b[1]);
        }).map(function (i) {
          return i[0];
        });
      };

      this.commonVars = sort(common); // Unfilterable
      this.componentsVars = sort(other); // Filterable
    },
    delayChangeColors: function delayChangeColors(color) {
      var _this4 = this;

      clearTimeout(this.pickerTimeout);
      this.pickerTimeout = setTimeout(function () {
        return _this4.changeColors(color);
      }, 300);
    },


    // Parse picker color
    changeColors: function changeColors(color) {
      this.loading = 'picker';
      var source = /hsv/i.test(color.source) ? 'rgba' : color.source;

      var value = source === 'hex' ? color[source] : source + '(' + source.split('').map(function (l) {
        return (/s|l/.test(l) ? (color[source][l] * 100).toFixed(2) + '%' : +color[source][l].toFixed(2)
        );
      }) + ')';

      this.saveVars(value);
    },


    // Update or clear variables and compile
    saveVars: function saveVars(value) {
      var _this5 = this;

      if (typeof value === 'string') {
        this.customVars = extends_default()({}, this.customVars, defineProperty_default()({}, this.currentVar, value));
      } else {
        this.customVars = value || {};
      }

      // Update with new value
      var re = new RegExp(this.currentVar + '\\s*:.*;\\n', 'img');
      this.customTheme = (this.customTheme || this.fixedTheme).replace(re, this.currentVar + ': ' + value + ';\n');

      css_processor.compileVariables(this.customTheme).then(function (theme) {
        _this5.compiledCustomTheme = theme;

        var compiledVars = TRCustomizer_themeToVars(theme);
        var vars = {};
        keys_default()(compiledVars).forEach(function (v) {
          if (compiledVars[v] !== _this5.compiledOriginalVars[v]) {
            vars[v] = compiledVars[v];
          }
        });
        _this5.compiledCustomVars = vars;

        _this5.bulkContent = _this5.customTheme;
        cache.set('bulk-content', _this5.bulkContent, true);
        _this5.$emit('variable');
      });
    },


    // Clear all
    clearVars: function clearVars() {
      this.customVars = {};
      if (this.compiledCustomTheme !== '') {
        this.loading = 'clear';
        this.customTheme = this.fixedTheme;
        this.bulkContent = this.customTheme;
        this.compiledCustomVars = {};
        this.compiledCustomTheme = '';
        this.currentVar = '';
        cache.remove('bulk-content');
        this.$emit('variable');
      }
    },


    // Restore button
    restoreBulk: function restoreBulk() {
      this.bulkContent = this.customTheme;
    },


    // Extract changed variables and compile
    saveBulk: function saveBulk() {
      var _this6 = this;

      if (this.bulkContent !== this.customTheme) {
        this.loading = 'savebulk';
        css_processor.compileVariables(this.bulkContent).then(function (theme) {
          _this6.compiledCustomTheme = theme;

          var bulkVars = TRCustomizer_themeToVars(_this6.bulkContent);
          var compiledVars = TRCustomizer_themeToVars(theme);
          var diffBulkVars = {};
          var diffCompiledVars = {};

          keys_default()(bulkVars).forEach(function (v) {
            // Store only modified values.
            // Otherwise, square previews would not fallback to original theme values.
            if (bulkVars[v] !== _this6.originalVars[v]) {
              diffBulkVars[v] = bulkVars[v];
              diffCompiledVars[v] = compiledVars[v];
            }
          });

          _this6.customVars = diffBulkVars; // Real theme variables
          _this6.compiledCustomVars = diffCompiledVars; // Compiled values for square preview

          _this6.customTheme = _this6.bulkContent;
          cache.set('bulk-content', _this6.bulkContent, true);
          _this6.$emit('variable', function () {
            return _this6.$modal.hide('bulk');
          });
        });
      } else {
        this.$modal.hide('bulk');
      }
    },
    getVariableType: function getVariableType(key) {
      if ((this.customVars[key] || this.originalVars[key] || '').indexOf('var') !== -1) {
        return 'varreference';
      }
      return this.customVars[key] && this.customVars[key] !== this.originalVars[key] ? 'varmodified' : 'varnormal';
    },
    getVariableTypeColor: function getVariableTypeColor(key) {
      var type = this.getVariableType(key);
      if (type === 'varmodified') {
        return '#999';
      }
      return type === 'varnormal' ? '#ebebeb' : '#ccc';
    }
  }
});

// ESLint complains about CSS length...
/* eslint-disable max-len */
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bb9eec3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TRCustomizer.vue
var TRCustomizer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tr-customizer",on:{"wheel":function($event){_vm.$refs.picker && (_vm.$refs.picker.visible = false)}}},[_c('div',{staticClass:"tr-customizer__toolbar top"},[_c('TRButton',{attrs:{"icon":"pencil","label":_vm.$t('bulk')},on:{"click":function($event){_vm.$modal.show('bulk')}}}),_vm._v(" "),_c('TRButton',{attrs:{"label":_vm.$t('clear'),"inverted":"","loading":_vm.loading === 'clear',"disabled":!_vm.compiledCustomTheme},on:{"click":_vm.clearVars}}),_vm._v(" "),_c('TRCloseButton',{on:{"click":function($event){_vm.showCustomizer = false}}})],1),_vm._v(" "),_c('modal',{attrs:{"name":"bulk","reset":"","height":"auto","width":"800px"}},[_c('div',{staticClass:"tr-customizer__bulk"},[_c('TRCloseButton',{on:{"click":function($event){_vm.$modal.hide('bulk')}}}),_vm._v(" "),_c('div',{staticClass:"tr-customizer__bulk--editor"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.bulkContent),expression:"bulkContent"}],attrs:{"id":"bulkEditor"},domProps:{"value":(_vm.bulkContent)},on:{"input":function($event){if($event.target.composing){ return; }_vm.bulkContent=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"tr-customizer__toolbar"},[_c('i18n',{attrs:{"path":"cssnext","tag":"span"}},[_c('a',{attrs:{"href":"http://cssnext.io/features/","target":"_blank"}},[_vm._v("cssnext")])]),_vm._v(" "),_c('TRButton',{attrs:{"label":_vm.$t('restore'),"inverted":""},on:{"click":_vm.restoreBulk}}),_vm._v(" "),_c('TRButton',{staticStyle:{"margin-left":"12px"},attrs:{"label":_vm.$t('save'),"loading":_vm.loading === 'savebulk'},on:{"click":function($event){_vm.saveBulk()}}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"tr-customizer__scrollable scrollable"},[_c('ul',{staticClass:"tr-customizer__variables"},_vm._l((_vm.visibleVars),function(key,index){return _c('li',{key:(_vm.version + "-" + key),class:{ 'first': index === 0 },attrs:{"separator":index === 0
          ? _vm.$t('vargeneral')
          : (index === _vm.commonVars.length && _vm.$t('varcomponent') || false)}},[_c('label',[_c('a',[_c('span',{staticClass:"tr-customizer__color"},[_c('input',{directives:[{name:"popover",rawName:"v-popover.left",value:({ name: 'picker' }),expression:"{ name: 'picker' }",modifiers:{"left":true}},{name:"model",rawName:"v-model",value:(_vm.currentVar),expression:"currentVar"}],attrs:{"type":"radio"},domProps:{"value":key,"checked":_vm._q(_vm.currentVar,key)},on:{"change":function($event){_vm.currentVar=key}}}),_vm._v(" "),_c('span'),_vm._v(" "),_c('span',{style:({
                  backgroundColor: _vm.compiledCustomVars[key]
                    || _vm.compiledOriginalVars[key]
                })})]),_vm._v(" "),_c('span',{staticClass:"tr-customizer__label"},[_vm._v("\n              "+_vm._s(_vm._f("toLabel")(key))+"\n            ")]),_vm._v(" "),_c('span',{staticClass:"tr-customizer__indicator tooltip-left",style:({ backgroundColor: _vm.getVariableTypeColor(key) }),attrs:{"data-tooltip":_vm.$t(_vm.getVariableType(key))}})])])])}))]),_vm._v(" "),_c('div',{staticClass:"tr-customizer__toolbar bottom"},[_c('TRButton',{staticClass:"tr-customizer__download",attrs:{"icon":"download","label":_vm.$t('download')},on:{"click":function($event){_vm.$emit('generator')}}})],1),_vm._v(" "),_c('portal',{attrs:{"to":"picker"}},[_c('popover',{ref:"picker",staticClass:"tr-customizer__popover",class:{ loader: _vm.loading === 'picker' },staticStyle:{"width":"inherit"},attrs:{"name":"picker"}},[_c('color-picker',{on:{"input":function($event){_vm.delayChangeColors($event)}},model:{value:(_vm.colors),callback:function ($$v) {_vm.colors=$$v},expression:"colors"}})],1)],1)],1)}
var TRCustomizer_staticRenderFns = []
var TRCustomizer_esExports = { render: TRCustomizer_render, staticRenderFns: TRCustomizer_staticRenderFns }
/* harmony default export */ var components_TRCustomizer = (TRCustomizer_esExports);
// CONCATENATED MODULE: ./src/components/TRCustomizer.vue
function TRCustomizer_injectStyle (ssrContext) {
  __webpack_require__("s9fu")
}
var TRCustomizer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var TRCustomizer___vue_template_functional__ = false
/* styles */
var TRCustomizer___vue_styles__ = TRCustomizer_injectStyle
/* scopeId */
var TRCustomizer___vue_scopeId__ = "data-v-0bb9eec3"
/* moduleIdentifier (server only) */
var TRCustomizer___vue_module_identifier__ = null
var TRCustomizer_Component = TRCustomizer_normalizeComponent(
  TRCustomizer,
  components_TRCustomizer,
  TRCustomizer___vue_template_functional__,
  TRCustomizer___vue_styles__,
  TRCustomizer___vue_scopeId__,
  TRCustomizer___vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("QYEI")
if (typeof customBlock === "function") {  customBlock(TRCustomizer_Component)}


/* harmony default export */ var src_components_TRCustomizer = (TRCustomizer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/TRCheckbox.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var TRCheckbox = ({
  name: 'TRCheckbox',
  model: {
    prop: 'model',
    event: 'change'
  },
  props: {
    model: {
      type: [Boolean, Array],
      default: undefined
    },
    value: {
      type: [Number, String],
      default: undefined
    }
  },
  data: function data() {
    return {
      cachedValue: false
    };
  },

  watch: {
    model: function model() {
      this.updateValue();
    }
  },
  mounted: function mounted() {
    this.updateValue();
  },

  methods: {
    updateValue: function updateValue() {
      if (this.model instanceof Array) {
        this.cachedValue = this.model.indexOf(this.value) >= 0;
      } else {
        this.cachedValue = this.model;
      }
      this.$refs.input.checked = this.cachedValue;
    },
    onChange: function onChange(event) {
      var _event$target = event.target,
          value = _event$target.value,
          checked = _event$target.checked;

      var newValue = void 0;

      if (this.model instanceof Array) {
        // Is Array
        var index = this.model.indexOf(value);
        var included = index >= 0;

        if (included && !checked) {
          newValue = [].concat(toConsumableArray_default()(this.model.slice(0, index)), toConsumableArray_default()(this.model.slice(index + 1, this.model.length)));
        }

        if (!included && checked) {
          newValue = [].concat(toConsumableArray_default()(this.model), [value]);
        }
      } else {
        // Is Boolean
        newValue = checked;
      }

      // Emit if value changed
      if (newValue !== undefined) {
        this.$emit('change', newValue);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-684f1b5a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TRCheckbox.vue
var TRCheckbox_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"tr-checkbox",attrs:{"checked":_vm.cachedValue}},[_c('input',_vm._b({ref:"input",staticClass:"tr-checkbox__input",attrs:{"type":"checkbox"},domProps:{"value":_vm.value},on:{"change":_vm.onChange}},'input',_vm.$attrs,false)),_vm._v(" "),_c('span',{staticClass:"tr-checkbox__checkmark"})])}
var TRCheckbox_staticRenderFns = []
var TRCheckbox_esExports = { render: TRCheckbox_render, staticRenderFns: TRCheckbox_staticRenderFns }
/* harmony default export */ var components_TRCheckbox = (TRCheckbox_esExports);
// CONCATENATED MODULE: ./src/components/TRCheckbox.vue
function TRCheckbox_injectStyle (ssrContext) {
  __webpack_require__("IIii")
}
var TRCheckbox_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var TRCheckbox___vue_template_functional__ = false
/* styles */
var TRCheckbox___vue_styles__ = TRCheckbox_injectStyle
/* scopeId */
var TRCheckbox___vue_scopeId__ = "data-v-684f1b5a"
/* moduleIdentifier (server only) */
var TRCheckbox___vue_module_identifier__ = null
var TRCheckbox_Component = TRCheckbox_normalizeComponent(
  TRCheckbox,
  components_TRCheckbox,
  TRCheckbox___vue_template_functional__,
  TRCheckbox___vue_styles__,
  TRCheckbox___vue_scopeId__,
  TRCheckbox___vue_module_identifier__
)

/* harmony default export */ var src_components_TRCheckbox = (TRCheckbox_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/TRRadio.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var TRRadio = ({
  name: 'TRRadio',
  model: {
    prop: 'model',
    event: 'change'
  },
  props: {
    model: {
      type: [Number, String],
      default: undefined
    },
    value: {
      type: [Number, String],
      default: undefined
    }
  },
  watch: {
    model: function model() {
      this.updateValue();
    }
  },
  mounted: function mounted() {
    this.updateValue();
  },

  methods: {
    updateValue: function updateValue() {
      this.$refs.input.checked = this.model === this.value;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-635e1890","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TRRadio.vue
var TRRadio_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"tr-radio",attrs:{"checked":_vm.model === _vm.value}},[_c('input',_vm._b({ref:"input",staticClass:"tr-radio__input",attrs:{"type":"radio"},domProps:{"value":_vm.value},on:{"change":function($event){$event.target.checked && _vm.$emit('change', _vm.value)}}},'input',_vm.$attrs,false)),_vm._v(" "),_c('span',{staticClass:"tr-radio__checkmark"})])}
var TRRadio_staticRenderFns = []
var TRRadio_esExports = { render: TRRadio_render, staticRenderFns: TRRadio_staticRenderFns }
/* harmony default export */ var components_TRRadio = (TRRadio_esExports);
// CONCATENATED MODULE: ./src/components/TRRadio.vue
function TRRadio_injectStyle (ssrContext) {
  __webpack_require__("kYuG")
}
var TRRadio_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var TRRadio___vue_template_functional__ = false
/* styles */
var TRRadio___vue_styles__ = TRRadio_injectStyle
/* scopeId */
var TRRadio___vue_scopeId__ = "data-v-635e1890"
/* moduleIdentifier (server only) */
var TRRadio___vue_module_identifier__ = null
var TRRadio_Component = TRRadio_normalizeComponent(
  TRRadio,
  components_TRRadio,
  TRRadio___vue_template_functional__,
  TRRadio___vue_styles__,
  TRRadio___vue_scopeId__,
  TRRadio___vue_module_identifier__
)

/* harmony default export */ var src_components_TRRadio = (TRRadio_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/TRSelect.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var TRSelect = ({
  name: 'TRSelect',
  model: {
    event: 'input',
    prop: 'model'
  },

  props: {
    label: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    keyPrefix: {
      type: String,
      default: ''
    },
    model: {
      type: [Number, String],
      default: undefined
    }
  },

  watch: {
    model: function model() {
      var _this = this;

      setTimeout(function () {
        _this.$refs.select.value = _this.model;
      }, 0);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5db498c4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TRSelect.vue
var TRSelect_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"tr-select"},[(!!_vm.label)?_c('div',{staticClass:"tr-select__label"},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"tr-select__input"},[_c('select',{ref:"select",on:{"change":function($event){_vm.$emit('change', $event)},"input":function($event){_vm.$emit('input', $event.target.value)}}},[(_vm.options.length === 0)?_c('option',{attrs:{"value":"-1","selected":""}},[_vm._v("\n        Loading\n      ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.options),function(option,$index){return _c('option',{key:_vm.keyPrefix + option,domProps:{"value":$index}},[_vm._v("\n        "+_vm._s(option)+"\n      ")])}),_vm._v(" "),_vm._t("after-options")],2)])])}
var TRSelect_staticRenderFns = []
var TRSelect_esExports = { render: TRSelect_render, staticRenderFns: TRSelect_staticRenderFns }
/* harmony default export */ var components_TRSelect = (TRSelect_esExports);
// CONCATENATED MODULE: ./src/components/TRSelect.vue
function TRSelect_injectStyle (ssrContext) {
  __webpack_require__("C9tR")
}
var TRSelect_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var TRSelect___vue_template_functional__ = false
/* styles */
var TRSelect___vue_styles__ = TRSelect_injectStyle
/* scopeId */
var TRSelect___vue_scopeId__ = "data-v-5db498c4"
/* moduleIdentifier (server only) */
var TRSelect___vue_module_identifier__ = null
var TRSelect_Component = TRSelect_normalizeComponent(
  TRSelect,
  components_TRSelect,
  TRSelect___vue_template_functional__,
  TRSelect___vue_styles__,
  TRSelect___vue_scopeId__,
  TRSelect___vue_module_identifier__
)

/* harmony default export */ var src_components_TRSelect = (TRSelect_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-content-loading/dist/vuecontentloading.js
var vuecontentloading = __webpack_require__("/j7X");
var vuecontentloading_default = /*#__PURE__*/__webpack_require__.n(vuecontentloading);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/TRMenu.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var TRMenu = ({
  name: 'TRMenu',
  components: {
    TRCheckbox: src_components_TRCheckbox,
    TRRadio: src_components_TRRadio,
    TRSelect: src_components_TRSelect,
    VueContentLoading: vuecontentloading_default.a
  },

  data: function data() {
    return {
      platforms: ['All', 'iOS', 'Android'],
      selectedTheme: Number(cache.get('selected-theme')) || 0
    };
  },

  computed: extends_default()({}, store_mapMutationState(['cssComponents', 'loading', 'selectedCategory', 'selectedPlatform', 'showCustomizer', 'version', 'versionIndex', 'versions', 'themes']), {
    categories: function categories() {
      return this.$store.getters.categories;
    }
  }),

  methods: {
    versionChange: function versionChange(event) {
      var value = Number(event.target.value);
      if (value === -2) {
        // Redirect to Theme Roller for <= 2.1.0
        window.location.replace('https://components.onsen.io/old-theme-roller.html');
      } else {
        this.loading = 'version';

        this.selectedTheme = 0;
        cache.set('selected-theme', 0, true);

        cache.set('selected-version', this.versions.length - value, true);
        this.$emit('version', this.versions[value] || '');
      }
    },
    themeChange: function themeChange(event) {
      if (event.target.type === 'radio') {
        var value = event.target.value;

        cache.set('selected-theme', value, true);
        this.$emit('theme', this.themes[value].theme.name);
      }
    },
    toId: function toId(string) {
      return util.toId(string);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9faf8a8c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TRMenu.vue
var TRMenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tr-menu"},[_c('div',{staticClass:"tr-menu__subtitle inverted",class:{ loader: _vm.loading === 'version' }},[_c('span',[_vm._v("Onsen UI")]),_vm._v(" "+_vm._s(_vm.$t('version'))+"\n  ")]),_vm._v(" "),_c('TRSelect',{staticClass:"tr-menu__version",attrs:{"options":_vm.versions},on:{"change":_vm.versionChange},model:{value:(_vm.versionIndex),callback:function ($$v) {_vm.versionIndex=$$v},expression:"versionIndex"}},[_c('option',{attrs:{"slot":"after-options","value":"-2"},slot:"after-options"},[_vm._v("<= 2.1.0")])]),_vm._v(" "),_c('div',{staticClass:"tr-menu__subtitle inverted",class:{ loader: _vm.loading === 'theme' }},[_vm._v("\n    "+_vm._s(_vm.$t('theme'))+"\n  ")]),_vm._v(" "),_c('ul',{staticClass:"tr-menu__list themes",on:{"change":function($event){_vm.loading = 'theme'; _vm.themeChange($event)}}},[_vm._l((_vm.themes.map(function (t) { return t.label; })),function(label,$index){return _c('li',{key:(_vm.version + "-" + label)},[_c('label',[_c('a',[_c('TRRadio',{staticClass:"input",attrs:{"value":$index},model:{value:(_vm.selectedTheme),callback:function ($$v) {_vm.selectedTheme=$$v},expression:"selectedTheme"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(label))])],1)])])}),_vm._v(" "),_c('li',{on:{"change":function($event){$event.stopPropagation();}}},[_c('label',[_c('a',{staticClass:"tr-menu__customizer"},[_c('TRCheckbox',{staticClass:"input",model:{value:(_vm.showCustomizer),callback:function ($$v) {_vm.showCustomizer=$$v},expression:"showCustomizer"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('customize')))])],1)])])],2),_vm._v(" "),_c('div',{staticClass:"tr-menu__subtitle inverted",class:{ loader: _vm.loading === 'platform' }},[_vm._v("\n    "+_vm._s(_vm.$t('platforms'))+"\n  ")]),_vm._v(" "),_c('ul',{staticClass:"tr-menu__list platforms"},_vm._l((_vm.platforms),function(platform){return _c('li',{key:(_vm.version + "-" + platform),on:{"change":function($event){_vm.loading = 'platform'}}},[_c('label',[_c('a',[_c('TRRadio',{staticClass:"input",attrs:{"value":platform},model:{value:(_vm.selectedPlatform),callback:function ($$v) {_vm.selectedPlatform=$$v},expression:"selectedPlatform"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(platform))])],1)])])})),_vm._v(" "),_c('div',{staticClass:"tr-menu__subtitle"},[_vm._v("\n    "+_vm._s(_vm.$t('categories'))+"\n  ")]),_vm._v(" "),_c('ul',{staticClass:"tr-menu__list categories"},[(_vm.categories.length === 0)?_vm._l((10),function(n){return _c('li',{key:n},[_c('label',[_c('a',[_c('vue-content-loading',{attrs:{"width":26,"height":2,"speed":2,"primary":"#f3f3f3","secondary":"#ecebeb"}},[_c('rect',{attrs:{"x":"0","y":"0","rx":"1","ry":"1","width":"16","height":"2"}})])],1)])])}):_vm._e(),_vm._v(" "),_vm._l((_vm.categories),function(category){return _c('li',{key:(_vm.version + "-" + category)},[_c('label',[_c('a',{class:category === _vm.selectedCategory ? 'current' : '',attrs:{"href":("#" + (_vm.toId(category)))},on:{"click":function($event){_vm.selectedCategory = category}}},[_c('span',[_vm._v(_vm._s(category))])])])])})],2)],1)}
var TRMenu_staticRenderFns = []
var TRMenu_esExports = { render: TRMenu_render, staticRenderFns: TRMenu_staticRenderFns }
/* harmony default export */ var components_TRMenu = (TRMenu_esExports);
// CONCATENATED MODULE: ./src/components/TRMenu.vue
function TRMenu_injectStyle (ssrContext) {
  __webpack_require__("78C+")
}
var TRMenu_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var TRMenu___vue_template_functional__ = false
/* styles */
var TRMenu___vue_styles__ = TRMenu_injectStyle
/* scopeId */
var TRMenu___vue_scopeId__ = "data-v-9faf8a8c"
/* moduleIdentifier (server only) */
var TRMenu___vue_module_identifier__ = null
var TRMenu_Component = TRMenu_normalizeComponent(
  TRMenu,
  components_TRMenu,
  TRMenu___vue_template_functional__,
  TRMenu___vue_styles__,
  TRMenu___vue_scopeId__,
  TRMenu___vue_module_identifier__
)

/* customBlocks */
var TRMenu_customBlock = __webpack_require__("yuGJ")
if (typeof TRMenu_customBlock === "function") {  TRMenu_customBlock(TRMenu_Component)}


/* harmony default export */ var src_components_TRMenu = (TRMenu_Component.exports);

// EXTERNAL MODULE: ./node_modules/jszip/lib/index.js
var jszip_lib = __webpack_require__("WgY6");
var jszip_lib_default = /*#__PURE__*/__webpack_require__.n(jszip_lib);

// EXTERNAL MODULE: ./node_modules/file-saver/FileSaver.js
var FileSaver = __webpack_require__("lDdF");
var FileSaver_default = /*#__PURE__*/__webpack_require__.n(FileSaver);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/TRGenerator.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var TRGenerator_re = /(global|util|combination)/i;

/* harmony default export */ var TRGenerator = ({
  name: 'TRGenerator',
  components: {
    TRButton: src_components_TRButton,
    TRCheckbox: src_components_TRCheckbox
  },
  filters: {
    capitalizeAll: function capitalizeAll(string) {
      return util.capitalizeAll(string);
    }
  },
  data: function data() {
    return {
      components: null
    };
  },

  computed: extends_default()({}, store_mapMutationState(['customTheme', 'fullComponentsIndex', 'loading', 'rootCSS', 'theme', 'version']), {
    fullComponentsList: function fullComponentsList() {
      return (this.fullComponentsIndex.match(/'([./-\w]+)\.css'/img) || []).filter(function (m) {
        return !TRGenerator_re.test(m);
      }).map(function (m) {
        return util.toLabel(m.slice(3, -5));
      }).sort();
    },

    selectedComponents: {
      get: function get() {
        return this.components ? this.components : this.fullComponentsList;
      },
      set: function set(value) {
        this.components = value;
      }
    }
  }),

  methods: {
    generate: function generate() {
      var _this = this;

      var includedComponents = this.selectedComponents.map(function (c) {
        return util.toId(c) + '.css';
      });

      var index = this.fullComponentsIndex.split('\n').filter(function (line) {
        return TRGenerator_re.test(line) || includedComponents.some(function (c) {
          return line.indexOf(c) !== -1;
        });
      }).join('\n');

      var precss = css_processor.replace(this.rootCSS, this.theme, index);

      css_processor.compile(precss).then(function (css) {
        var zip = new jszip_lib_default.a();
        zip.file('readme.md', '\n            Generated by Onsen UI Theme Roller (https://onsenui.github.io/theme-roller)\n            for Onsen UI version ' + _this.version + '.\n\n            Copy \'theme.css\' content in Bulk Editor to further modify the theme.');

        var banner = '/* Custom Theme for Onsen UI ' + _this.version + ' */\n\n';

        zip.file('onsen-css-components.css', banner + css);
        zip.file('theme.css', banner + _this.customTheme);

        css_processor.minify(css).then(function (mincss) {
          zip.file('onsen-css-components.min.css', banner + mincss);
          zip.generateAsync({ type: 'blob' }).then(function (content) {
            FileSaver_default.a.saveAs(content, 'onsen-css-theme.zip');
            setTimeout(function () {
              _this.loading = false;
            }, 100);
          });
        });
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a655e156","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TRGenerator.vue
var TRGenerator_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tr-generator"},[_c('div',{staticClass:"tr-generator__message"},[_vm._v("\n    "+_vm._s(_vm.$t('description'))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"tr-generator__components"},[_c('ul',{staticClass:"scrollable"},_vm._l((_vm.fullComponentsList),function(component){return _c('li',{key:(_vm.version + "-" + component)},[_c('label',[_c('a',[_c('TRCheckbox',{attrs:{"value":component},model:{value:(_vm.selectedComponents),callback:function ($$v) {_vm.selectedComponents=$$v},expression:"selectedComponents"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("capitalizeAll")(component)))])],1)])])}))]),_vm._v(" "),_c('div',{staticClass:"tr-generator__toolbar"},[_c('TRButton',{attrs:{"icon":"download","label":_vm.$t('generate'),"loading":_vm.loading === 'generator'},on:{"click":function($event){_vm.loading = 'generator'; _vm.generate()}}})],1)])}
var TRGenerator_staticRenderFns = []
var TRGenerator_esExports = { render: TRGenerator_render, staticRenderFns: TRGenerator_staticRenderFns }
/* harmony default export */ var components_TRGenerator = (TRGenerator_esExports);
// CONCATENATED MODULE: ./src/components/TRGenerator.vue
function TRGenerator_injectStyle (ssrContext) {
  __webpack_require__("Vx78")
}
var TRGenerator_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var TRGenerator___vue_template_functional__ = false
/* styles */
var TRGenerator___vue_styles__ = TRGenerator_injectStyle
/* scopeId */
var TRGenerator___vue_scopeId__ = "data-v-a655e156"
/* moduleIdentifier (server only) */
var TRGenerator___vue_module_identifier__ = null
var TRGenerator_Component = TRGenerator_normalizeComponent(
  TRGenerator,
  components_TRGenerator,
  TRGenerator___vue_template_functional__,
  TRGenerator___vue_styles__,
  TRGenerator___vue_scopeId__,
  TRGenerator___vue_module_identifier__
)

/* customBlocks */
var TRGenerator_customBlock = __webpack_require__("T2O3")
if (typeof TRGenerator_customBlock === "function") {  TRGenerator_customBlock(TRGenerator_Component)}


/* harmony default export */ var src_components_TRGenerator = (TRGenerator_Component.exports);

// EXTERNAL MODULE: ./src/assets/logos/apple.svg
var apple = __webpack_require__("3gpg");
var apple_default = /*#__PURE__*/__webpack_require__.n(apple);

// EXTERNAL MODULE: ./src/assets/logos/android.svg
var android = __webpack_require__("T3NL");
var android_default = /*#__PURE__*/__webpack_require__.n(android);

// EXTERNAL MODULE: ./src/assets/logos/js.svg
var js = __webpack_require__("VjtO");
var js_default = /*#__PURE__*/__webpack_require__.n(js);

// EXTERNAL MODULE: ./src/assets/logos/vue.svg
var vue = __webpack_require__("08u2");
var vue_default = /*#__PURE__*/__webpack_require__.n(vue);

// EXTERNAL MODULE: ./src/assets/logos/react.svg
var react = __webpack_require__("RFA3");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/assets/logos/angular1.svg
var angular1 = __webpack_require__("lwEJ");
var angular1_default = /*#__PURE__*/__webpack_require__.n(angular1);

// EXTERNAL MODULE: ./src/assets/logos/angular2.svg
var angular2 = __webpack_require__("tc0q");
var angular2_default = /*#__PURE__*/__webpack_require__.n(angular2);

// EXTERNAL MODULE: ./src/assets/logos/css.svg
var logos_css = __webpack_require__("q7Qo");
var css_default = /*#__PURE__*/__webpack_require__.n(logos_css);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/TRPreviewItem.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ var TRPreviewItem = ({
  name: 'TRPreviewItem',
  props: {
    component: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },

  data: function data() {
    return {
      icons: {
        platforms: {
          apple: apple_default.a,
          android: android_default.a
        },
        frameworks: {
          js: js_default.a,
          vue: vue_default.a,
          react: react_default.a,
          angular1: angular1_default.a,
          angular2: angular2_default.a,
          css: css_default.a
        }
      },
      tooltip: {
        js: 'Web Components',
        vue: 'Vue.js',
        react: 'React',
        angular1: 'AngularJS',
        angular2: 'Angular 2+',
        css: 'HTML + CSS'
      }
    };
  },


  methods: {
    getLink: function getLink(framework) {
      var prefix = 'https://onsen.io/v2/api';
      var link = function link(el) {
        return prefix + '/' + framework + '/' + el + '.html';
      };
      var category = this.component.category;


      if (framework === 'css') {
        return prefix + '/css.html#' + util.toId(category) + '-category';
      }

      var element = void 0;

      if (['textarea', 'notification'].indexOf(category.toLowerCase()) === -1 && this.component.name !== 'Button Bar') {
        var fixedName = void 0;
        switch (category.toLowerCase()) {
          case 'radio button':
            fixedName = 'radio';
            break;
          case 'select input':
            fixedName = 'select';
            break;
          case 'text input':
            fixedName = 'input';
            break;
          default:
            fixedName = category;
        }

        var name = '' + util.toId(fixedName);

        switch (framework) {
          case 'react':
            element = util.capitalizeAll(util.toLabel(name)).replace(/\s+/, '');
            break;
          case 'vue':
            element = 'v-ons-' + name;
            break;
          default:
            element = 'ons-' + name;
        }
      }

      return element ? link(element) : '#';
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-805653ae","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TRPreviewItem.vue
var TRPreviewItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tr-preview-item"},[_c('div',{staticClass:"page tr-preview-item__box",class:_vm.component.name.toLowerCase().indexOf('material') !== -1 && 'page--material'},[_c('div',{staticStyle:{"width":"100%"},attrs:{"ontouchstart":" "},domProps:{"innerHTML":_vm._s(_vm.component.markup)}}),_vm._v(" "),_c('div',{staticClass:"tr-preview-item__links"},_vm._l((_vm.icons.frameworks),function(icon,framework){return _c('a',{key:framework,attrs:{"data-tooltip":_vm.tooltip[framework],"href":_vm.getLink(framework),"target":"_blank"}},[_c('i',{style:({ background: ("url(" + icon + ")") })})])}))]),_vm._v(" "),_c('div',{staticClass:"tr-preview-item__title"},[_vm._v("\n    "+_vm._s(_vm.component.name)+"\n    "),_c('i',{style:({
        background: ("url(" + (_vm.icons.platforms[/material/i.test(_vm.component.name) ? 'android' : 'apple']) + ")")
      })})])])}
var TRPreviewItem_staticRenderFns = []
var TRPreviewItem_esExports = { render: TRPreviewItem_render, staticRenderFns: TRPreviewItem_staticRenderFns }
/* harmony default export */ var components_TRPreviewItem = (TRPreviewItem_esExports);
// CONCATENATED MODULE: ./src/components/TRPreviewItem.vue
function TRPreviewItem_injectStyle (ssrContext) {
  __webpack_require__("4QSR")
}
var TRPreviewItem_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var TRPreviewItem___vue_template_functional__ = false
/* styles */
var TRPreviewItem___vue_styles__ = TRPreviewItem_injectStyle
/* scopeId */
var TRPreviewItem___vue_scopeId__ = "data-v-805653ae"
/* moduleIdentifier (server only) */
var TRPreviewItem___vue_module_identifier__ = null
var TRPreviewItem_Component = TRPreviewItem_normalizeComponent(
  TRPreviewItem,
  components_TRPreviewItem,
  TRPreviewItem___vue_template_functional__,
  TRPreviewItem___vue_styles__,
  TRPreviewItem___vue_scopeId__,
  TRPreviewItem___vue_module_identifier__
)

/* harmony default export */ var src_components_TRPreviewItem = (TRPreviewItem_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/TRPreviewPlaceholder.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var TRPreviewPlaceholder = ({
  name: 'TRPreviewPlaceholder',
  components: {
    VueContentLoading: vuecontentloading_default.a
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ada1ed14","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TRPreviewPlaceholder.vue
var TRPreviewPlaceholder_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tr-preview-placeholder"},[_c('vue-content-loading',{attrs:{"width":280,"height":236,"speed":2,"primary":"#f3f3f3","secondary":"#ecebeb"}},[_c('circle',{attrs:{"cx":"270","cy":"225","r":"6.6"}}),_vm._v(" "),_c('rect',{attrs:{"x":"12","y":"221","rx":"4","ry":"4","width":"144.5","height":"7.52"}}),_vm._v(" "),_c('rect',{attrs:{"x":"2","y":"6","rx":"5","ry":"5","width":"280","height":"201"}})])],1)}
var TRPreviewPlaceholder_staticRenderFns = []
var TRPreviewPlaceholder_esExports = { render: TRPreviewPlaceholder_render, staticRenderFns: TRPreviewPlaceholder_staticRenderFns }
/* harmony default export */ var components_TRPreviewPlaceholder = (TRPreviewPlaceholder_esExports);
// CONCATENATED MODULE: ./src/components/TRPreviewPlaceholder.vue
function TRPreviewPlaceholder_injectStyle (ssrContext) {
  __webpack_require__("mca8")
}
var TRPreviewPlaceholder_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var TRPreviewPlaceholder___vue_template_functional__ = false
/* styles */
var TRPreviewPlaceholder___vue_styles__ = TRPreviewPlaceholder_injectStyle
/* scopeId */
var TRPreviewPlaceholder___vue_scopeId__ = "data-v-ada1ed14"
/* moduleIdentifier (server only) */
var TRPreviewPlaceholder___vue_module_identifier__ = null
var TRPreviewPlaceholder_Component = TRPreviewPlaceholder_normalizeComponent(
  TRPreviewPlaceholder,
  components_TRPreviewPlaceholder,
  TRPreviewPlaceholder___vue_template_functional__,
  TRPreviewPlaceholder___vue_styles__,
  TRPreviewPlaceholder___vue_scopeId__,
  TRPreviewPlaceholder___vue_module_identifier__
)

/* harmony default export */ var src_components_TRPreviewPlaceholder = (TRPreviewPlaceholder_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/TRPreviewList.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var TRPreviewList = ({
  name: 'TRPreviewList',
  components: {
    TRPreviewItem: src_components_TRPreviewItem,
    TRPreviewPlaceholder: src_components_TRPreviewPlaceholder
  },

  data: function data() {
    return {
      groupedAnnotations: []
    };
  },


  computed: extends_default()({}, store_mapMutationState(['cssComponents', 'loading', 'selectedCategory', 'selectedPlatform', 'extraExamples']), {
    sortedCategories: function sortedCategories() {
      return keys_default()(this.groupedAnnotations).sort(); // eslint-disable-line
    },
    categoryId: function categoryId() {
      return this.sortedCategories.reduce(function (result, category) {
        return extends_default()({}, result, defineProperty_default()({}, category, util.toId(category)));
      }, {});
    }
  }),

  watch: {
    selectedPlatform: function selectedPlatform() {
      this.updateAnnotations();
    },

    cssComponents: {
      immediate: true,
      handler: function handler() {
        this.updateAnnotations();
      }
    }
  },

  methods: {
    updateAnnotations: function updateAnnotations() {
      var _this = this;

      var update = function update() {
        var p = _this.selectedPlatform;
        _this.groupedAnnotations = _this.cssComponents.map(function (component) {
          return component.annotation;
        }).filter(function (component) {
          var extraComponent = _this.extraExamples.find(function (extra) {
            return extra.name === component.name;
          });
          if (!extraComponent) {
            return true;
          }
          return !extraComponent.replace;
        }).concat(_this.extraExamples).reduce(function (result, annotation) {
          var md = /Material/i.test(annotation.name);

          if (p === 'All' || p === 'Android' && md || p === 'iOS' && !md) {
            var category = annotation.category;

            if (!Object.hasOwnProperty.call(result, category)) {
              result[category] = [];
            }
            result[category].push(annotation);
          }

          return result;
        }, {});

        _this.loading = false;
      };

      if (this.loading) {
        setTimeout(update, 100); // Asynchronous on UI click
      } else {
        update(); // Synchronous on initial load
      }
    },
    onScroll: function onScroll() {
      var _this2 = this;

      if (!this.lock) {
        this.lock = true;
        setTimeout(function () {
          _this2.lock = false;
        }, 100);

        var offset = 150;
        var categories = this.sortedCategories;
        for (var i = categories.length - 1; i >= 0; i -= 1) {
          var id = this.categoryId[categories[i]];
          if (this.$el.scrollTop > this.$refs['title.' + id][0].offsetTop - offset) {
            this.selectedCategory = this.sortedCategories[i];
            return;
          }
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3feb9fc8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TRPreviewList.vue
var TRPreviewList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tr-preview-list",on:{"scroll":_vm.onScroll}},[(_vm.sortedCategories.length === 0)?_c('section',[_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"tr-preview-list__category"},_vm._l((10),function(n){return _c('TRPreviewPlaceholder',{key:n})}))]):_vm._e(),_vm._v(" "),_vm._l((_vm.sortedCategories),function(category){return _c('section',{key:category},[_c('a',{staticClass:"tr-preview-list__header-link",attrs:{"href":("#" + (_vm.categoryId[category]))}},[_c('h3',{ref:("title." + (_vm.categoryId[category])),refInFor:true,staticClass:"tr-preview-list__title",attrs:{"id":_vm.categoryId[category]}},[_c('span',[_vm._v("\n          "+_vm._s(category)+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"tr-preview-list__category"},_vm._l((_vm.groupedAnnotations[category]),function(component){return _c('TRPreviewItem',{key:component.name,attrs:{"component":component}})}))])})],2)}
var TRPreviewList_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tr-preview-list__header-link"},[_c('h3',{staticClass:"tr-preview-list__title"},[_c('span',[_vm._v("Loading")])])])}]
var TRPreviewList_esExports = { render: TRPreviewList_render, staticRenderFns: TRPreviewList_staticRenderFns }
/* harmony default export */ var components_TRPreviewList = (TRPreviewList_esExports);
// CONCATENATED MODULE: ./src/components/TRPreviewList.vue
function TRPreviewList_injectStyle (ssrContext) {
  __webpack_require__("rSGq")
}
var TRPreviewList_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var TRPreviewList___vue_template_functional__ = false
/* styles */
var TRPreviewList___vue_styles__ = TRPreviewList_injectStyle
/* scopeId */
var TRPreviewList___vue_scopeId__ = "data-v-3feb9fc8"
/* moduleIdentifier (server only) */
var TRPreviewList___vue_module_identifier__ = null
var TRPreviewList_Component = TRPreviewList_normalizeComponent(
  TRPreviewList,
  components_TRPreviewList,
  TRPreviewList___vue_template_functional__,
  TRPreviewList___vue_styles__,
  TRPreviewList___vue_scopeId__,
  TRPreviewList___vue_module_identifier__
)

/* harmony default export */ var src_components_TRPreviewList = (TRPreviewList_Component.exports);

// EXTERNAL MODULE: ./src/extra-examples/extra-examples.json
var extra_examples = __webpack_require__("ss3p");
var extra_examples_default = /*#__PURE__*/__webpack_require__.n(extra_examples);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ var App = ({
  name: 'App',

  components: {
    TRCloseButton: src_components_TRCloseButton,
    TRCustomizer: src_components_TRCustomizer,
    TRPreviewList: src_components_TRPreviewList,
    TRMenu: src_components_TRMenu,
    TRGenerator: src_components_TRGenerator
  },

  data: function data() {
    return {
      styleElement: document.createElement('style'),
      menuOpen: false
    };
  },


  computed: extends_default()({}, store_mapMutationState(['browserslist', 'cssComponents', 'loading', 'extraExamples', 'fullComponentsIndex', 'rootCSS', 'showCustomizer', 'theme', 'themes', 'version', 'versionIndex', 'versions']), {
    style: {
      get: function get() {
        return this.styleElement.textContent;
      },
      set: function set(style) {
        this.styleElement.textContent = style;
      }
    },
    preCSS: function preCSS() {
      return css_processor.replace(this.rootCSS, this.theme, this.fullComponentsIndex);
    }
  }),

  created: function created() {
    var _this = this;

    this.styleElement.id = 'onsen-css-components';
    this.styleElement.type = 'text/css';
    document.head.insertBefore(this.styleElement, document.head.querySelector('style'));

    promise_default.a.all([api.getVersions(), api.getBrowserslist()]).then(function (_ref) {
      var _ref2 = slicedToArray_default()(_ref, 2),
          versions = _ref2[0],
          browserslist = _ref2[1];

      _this.versions = versions;
      _this.browserslist = browserslist;
      _this.versionIndex = cache.has('selected-version') ? versions.length - Number(cache.get('selected-version')) : 0;

      return _this.updateAllContent(versions[_this.versionIndex]);
    }).then(function () {
      if (window.location.hash) {
        var tmp = window.location.hash;
        window.location.hash = '';
        window.location.hash = tmp;
      }

      _this.$refs.main.onScroll();
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.styleElement.remove();
    this.styleElement = null;
  },


  methods: {
    fetchRootCSS: function fetchRootCSS(version) {
      return css_processor.get(api.urls.cssComponents(version));
    },
    fetchThemes: function fetchThemes(version) {
      var _this2 = this;

      return api.getThemes(version).then(function (themes) {
        _this2.themes = themes;
        return api.getThemeCSS(version, themes[Number(cache.get('selected-theme')) || 0].theme.name);
      });
    },
    fetchComponentsIndex: function fetchComponentsIndex(version) {
      return api.getComponentsIndex(version);
    },
    updateAllContent: function updateAllContent(version) {
      var _this3 = this;

      // Extra css component examples that aren't pulled from OnsenUI repo.
      // Examples are added here if we release a new version of OnsenUI and
      // forget to add new examples to the CSS.
      this.extraExamples = extra_examples_default.a.filter(function (e) {
        return e.versions.includes(version);
      });

      return promise_default.a.all([this.fetchRootCSS(version), this.fetchThemes(version), this.fetchComponentsIndex(version)]).then(function (result) {
        _this3.version = version;

        var _result = slicedToArray_default()(result, 3);

        _this3.rootCSS = _result[0];
        _this3.theme = _result[1];
        _this3.fullComponentsIndex = _result[2];


        return _this3.updateStyle().then(function (css) {
          _this3.cssComponents = ancss_default.a.parse(css, {
            detect: function detect(line) {
              return line.match(/^~/);
            }
          });
        });
      });
    },
    updateOnlyTheme: function updateOnlyTheme(name) {
      var _this4 = this;

      api.getThemeCSS(this.version, name).then(function (theme) {
        _this4.theme = theme;
        _this4.updateStyle();
      });
    },
    updateStyle: function updateStyle(callback) {
      var _this5 = this;

      return css_processor.compile(this.preCSS).then(function (css) {
        _this5.style = css;
        _this5.loading = false;
        if (callback instanceof Function) {
          callback();
        }
        return css;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01d4cec6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tr-app"},[_c('div',{staticClass:"tr-app__mask",class:{ hidden: !_vm.menuOpen },on:{"click":function($event){_vm.menuOpen = false}}}),_vm._v(" "),_c('div',{staticClass:"tr-app__side-left",class:{ open: _vm.menuOpen }},[_c('a',{staticClass:"tr-app__side-left__menu-button",on:{"click":function($event){_vm.menuOpen = !_vm.menuOpen}}}),_vm._v(" "),_c('TRMenu',{staticClass:"scrollable tr-app__offset-top",on:{"version":_vm.updateAllContent,"theme":_vm.updateOnlyTheme}})],1),_vm._v(" "),_c('div',{staticClass:"tr-app__main",class:{ customizer: _vm.showCustomizer }},[_c('div',{staticClass:"tr-app__content"},[_c('TRPreviewList',{ref:"main",staticClass:"scrollable tr-app__offset-top"}),_vm._v(" "),_c('a',{staticClass:"tr-app__content--gotop",on:{"click":function($event){_vm.$refs.main.$el.scrollTop = 0}}},[_c('span')])],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showCustomizer),expression:"showCustomizer"}],staticClass:"tr-app__side-right"},[_c('TRCustomizer',{on:{"variable":_vm.updateStyle,"generator":function($event){_vm.$modal.show('generator')}}})],1),_vm._v(" "),_c('modal',{attrs:{"name":"generator","height":"auto","width":"500px"}},[_c('div',{staticClass:"tr-app__generator"},[_c('TRCloseButton',{on:{"click":function($event){_vm.$modal.hide('generator')}}}),_vm._v(" "),_c('TRGenerator')],1)]),_vm._v(" "),_c('portal-target',{attrs:{"name":"picker"}})],1)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("6bUD")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = "data-v-01d4cec6"
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./src/styles/resources.css
var resources = __webpack_require__("vhUl");
var resources_default = /*#__PURE__*/__webpack_require__.n(resources);

// EXTERNAL MODULE: ./src/styles/global.css
var global = __webpack_require__("BuOL");
var global_default = /*#__PURE__*/__webpack_require__.n(global);

// CONCATENATED MODULE: ./src/main.js












vue_esm["default"].use(portal_vue_default.a);
vue_esm["default"].use(dist_default.a);
vue_esm["default"].use(vue_js_popover_dist_default.a);
vue_esm["default"].use(vue_i18n_esm["a" /* default */]);
vue_esm["default"].config.productionTip = false;
vue_esm["default"].prototype.$log = function () {
  var _console;

  return (_console = console).log.apply(_console, arguments);
}; // eslint-disable-line no-console

var qs = window.location.search.substring(1).split('&').reduce(function (acc, v) {
  return extends_default()({}, acc, defineProperty_default()({}, v.split('=')[0], v.split('=')[1]));
}, {});

var hostPrefix = window.location.hostname.split('.')[0] === 'ja' ? 'ja' : null;

var i18n = new vue_i18n_esm["a" /* default */]({
  locale: qs.lang || hostPrefix || 'en',
  fallbackLocale: 'en'
});

/* eslint-disable no-new */
new vue_esm["default"]({
  el: '#app',
  store: src_store,
  i18n: i18n,
  beforeCreate: function beforeCreate() {
    var wl = window.location;
    if ('customize' in qs || 'customizer' in qs) {
      src_store.commit('showCustomizer', true);
      window.history.replaceState({}, document.title, wl.protocol + '//' + wl.host + wl.pathname + wl.hash);
    }
  },

  render: function render(h) {
    return h(src_App);
  }
});

/***/ }),

/***/ "QYEI":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"bulk":"Bulk Edit","clear":"Clear","cssnext":"Any {0} color feature can be used here.","download":"Download","restore":"Restore","save":"Save changes","varcomponent":"Component Variables","vargeneral":"General Variables","varmodified":"Modified variable","varnormal":"Normal variable","varreference":"Reference variable"},"ja":{"bulk":"編集","clear":"クリア","cssnext":"{0} で使える任意の色が利用できます。","download":"ダウンロード","restore":"もとに戻す","save":"保存","varcomponent":"コンポーネント変数","vargeneral":"共通変数","varmodified":"変更済み","varnormal":"未変更","varreference":"他の変数に依存"}}')
}


/***/ }),

/***/ "RFA3":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "Rouy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T2O3":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"generate":"Generate and Download","description":"You can also remove components you don\u0027t need from your custom CSS file. What should be included?\\n"},"ja":{"generate":"生成 & ダウンロード","description":"カスタム CSS ファイルに含めるコンポーネントを選択してください。 不要なコンポーネントは除外することができます。\\n"}}')
}


/***/ }),

/***/ "T3NL":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyMS4xLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0i44Os44Kk44Ok44O8XzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCINCgkgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjYgMjAiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDI2IDIwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPg0KCS5zdDB7ZmlsbDojQTRDNDM5O30NCjwvc3R5bGU+DQo8cGF0aCBpZD0iWE1MSURfNDUxXyIgY2xhc3M9InN0MCIgZD0iTTYuOCw2LjhjLTAuNiwwLTEuMSwwLjUtMS4xLDEuMWwwLDQuN2MwLDAuNiwwLjUsMS4xLDEuMSwxLjFjMC42LDAsMS4xLTAuNSwxLjEtMS4xbDAtNC43DQoJQzcuOSw3LjMsNy40LDYuOCw2LjgsNi44IE0xNS43LDIuNmwwLjgtMS40YzAtMC4xLDAtMC4yLTAuMS0wLjJjLTAuMSwwLTAuMiwwLTAuMiwwLjFsLTAuOCwxLjRjLTAuNy0wLjMtMS40LTAuNS0yLjItMC41DQoJYy0wLjgsMC0xLjUsMC4yLTIuMiwwLjVsLTAuOC0xLjRDMTAuMywxLDEwLjIsMSwxMC4xLDFjLTAuMSwwLTAuMSwwLjEtMC4xLDAuMmwwLjgsMS40Yy0xLjUsMC44LTIuNiwyLjMtMi42LDRsMTAsMA0KCUMxOC4zLDQuOSwxNy4zLDMuNCwxNS43LDIuNiBNMTEsNC44Yy0wLjIsMC0wLjQtMC4yLTAuNC0wLjRDMTAuNiw0LjIsMTAuOCw0LDExLDRjMC4yLDAsMC40LDAuMiwwLjQsMC40QzExLjQsNC42LDExLjIsNC44LDExLDQuOA0KCSBNMTUuNiw0LjhjLTAuMiwwLTAuNC0wLjItMC40LTAuNGMwLTAuMiwwLjItMC40LDAuNC0wLjRDMTUuOCw0LDE2LDQuMiwxNiw0LjRDMTYsNC42LDE1LjgsNC44LDE1LjYsNC44IE04LjMsN2wwLDcuMg0KCWMwLDAuNywwLjUsMS4yLDEuMiwxLjJsMC44LDBsMCwyLjVjMCwwLjYsMC41LDEuMSwxLjEsMS4xYzAuNiwwLDEuMS0wLjUsMS4xLTEuMWwwLTIuNWwxLjUsMGwwLDIuNWMwLDAuNiwwLjUsMS4xLDEuMSwxLjENCgljMC42LDAsMS4xLTAuNSwxLjEtMS4xbDAtMi41bDAuOCwwYzAuNywwLDEuMi0wLjUsMS4yLTEuMmwwLTcuMkw4LjMsN3ogTTIwLjksNy45YzAtMC42LTAuNS0xLjEtMS4xLTEuMWMtMC42LDAtMS4xLDAuNS0xLjEsMS4xDQoJbDAsNC43YzAsMC42LDAuNSwxLjEsMS4xLDEuMWMwLjYsMCwxLjEtMC41LDEuMS0xLjFMMjAuOSw3Ljl6Ii8+DQo8L3N2Zz4NCg=="

/***/ }),

/***/ "VjtO":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIwLjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IlRyYWNlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIKCSB2aWV3Qm94PSIwIDAgMjYgMjAiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDI2IDIwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+Cgkuc3Qwe2ZpbGw6I0YwREI0Rjt9Cgkuc3Qxe2ZpbGw6IzMyMzMzMDt9Cjwvc3R5bGU+CjxyZWN0IHg9IjQiIHk9IjEiIGNsYXNzPSJzdDAiIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIvPgo8cGF0aCBjbGFzcz0ic3QxIiBkPSJNMTAuMSwxNS4yYzAuNSwwLjksMC44LDAuOSwxLjIsMC45YzAuNCwwLDAuOC0wLjMsMC44LTAuOFYxNVY5LjNoMS43bDAsNmMwLDEuMi0xLDIuMy0yLjMsMi4zCgljLTEuMSwwLTIuMS0wLjItMi44LTEuNUwxMC4xLDE1LjJ6Ii8+CjxwYXRoIGNsYXNzPSJzdDEiIGQ9Ik0xNi4xLDE1LjFjMC4zLDAuNiwwLjksMSwxLjYsMWMwLjksMCwxLjItMC40LDEuMi0wLjhjMC0wLjQtMC4zLTAuNy0wLjctMC45YzAsMC0wLjUtMC4yLTEuMi0wLjUKCWMtMC43LTAuMy0xLTAuNi0xLTAuNmMtMC41LTAuNC0wLjgtMS4xLTAuOC0xLjhjMC0xLjMsMS0yLjMsMi4zLTIuM2MwLjksMCwxLjksMC4xLDIuNiwxLjNsLTEuMywwLjhjLTAuMy0wLjYtMC43LTAuNy0xLjEtMC43CgljLTAuNCwwLTAuOCwwLjMtMC44LDAuOGMwLDAuMywwLjEsMC41LDAuMywwLjZjMCwwLDAuNCwwLjIsMC45LDAuNXMxLjIsMC42LDEuMiwwLjZjMC44LDAuNSwxLjIsMS4xLDEuMiwyLjJjMCwxLjMtMC45LDIuMy0zLDIuMwoJYy0xLjIsMC0yLjQtMC43LTIuOS0xLjdMMTYuMSwxNS4xeiIvPgo8L3N2Zz4K"

/***/ }),

/***/ "Vx78":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XuJW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'editableInput',
  props: {
    label: String,
    desc: String,
    value: [String, Number],
    max: Number,
    min: Number,
    arrowOffset: {
      type: Number,
      default: 1
    }
  },
  computed: {
    val: {
      get: function get() {
        return this.value;
      },
      set: function set(v) {
        if (!(this.max === undefined) && +v > this.max) {
          this.$refs.input.value = this.max;
        } else {
          return v;
        }
      }
    }
  },
  methods: {
    update: function update(e) {
      this.handleChange(e.target.value);
    },
    handleChange: function handleChange(newVal) {
      var data = {};
      data[this.label] = newVal;
      if (data.hex === undefined && data['#'] === undefined) {
        this.$emit('change', data);
      } else if (newVal.length > 5) {
        this.$emit('change', data);
      }
    },
    handleBlur: function handleBlur(e) {
      console.log(e);
    },
    handleKeyDown: function handleKeyDown(e) {
      var val = this.val;
      var number = Number(val);

      if (number) {
        var amount = this.arrowOffset || 1;

        if (e.keyCode === 38) {
          val = number + amount;
          this.handleChange(val);
          e.preventDefault();
        }

        if (e.keyCode === 40) {
          val = number - amount;
          this.handleChange(val);
          e.preventDefault();
        }
      }
    },
    handleDrag: function handleDrag(e) {
      console.log(e);
    },
    handleMouseDown: function handleMouseDown(e) {
      console.log(e);
    }
  }
};

/***/ }),

/***/ "ZarL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Checkboard = __webpack_require__("lKIo");

var _Checkboard2 = _interopRequireDefault(_Checkboard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Alpha',
  props: {
    value: Object,
    onChange: Function
  },
  components: {
    checkboard: _Checkboard2.default
  },
  computed: {
    colors: function colors() {
      return this.value;
    },
    gradientColor: function gradientColor() {
      var rgba = this.colors.rgba;
      var rgbStr = [rgba.r, rgba.g, rgba.b].join(',');
      return 'linear-gradient(to right, rgba(' + rgbStr + ', 0) 0%, rgba(' + rgbStr + ', 1) 100%)';
    }
  },
  methods: {
    handleChange: function handleChange(e, skip) {
      !skip && e.preventDefault();
      var container = this.$refs.container;
      var containerWidth = container.clientWidth;

      var xOffset = container.getBoundingClientRect().left + window.pageXOffset;
      var pageX = e.pageX || (e.touches ? e.touches[0].pageX : 0);
      var left = pageX - xOffset;

      var a;
      if (left < 0) {
        a = 0;
      } else if (left > containerWidth) {
        a = 1;
      } else {
        a = Math.round(left * 100 / containerWidth) / 100;
      }

      if (this.colors.a !== a) {
        this.$emit('change', {
          h: this.colors.hsl.h,
          s: this.colors.hsl.s,
          l: this.colors.hsl.l,
          a: a,
          source: 'rgba'
        });
      }
    },
    handleMouseDown: function handleMouseDown(e) {
      this.handleChange(e, true);
      window.addEventListener('mousemove', this.handleChange);
      window.addEventListener('mouseup', this.handleMouseUp);
    },
    handleMouseUp: function handleMouseUp() {
      this.unbindEventListeners();
    },
    unbindEventListeners: function unbindEventListeners() {
      window.removeEventListener('mousemove', this.handleChange);
      window.removeEventListener('mouseup', this.handleMouseUp);
    }
  }
};

/***/ }),

/***/ "bZbn":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("HGpZ").default;


/***/ }),

/***/ "fM5p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue-color/src/components/common/Alpha.vue
var Alpha = __webpack_require__("ZarL");
var Alpha_default = /*#__PURE__*/__webpack_require__.n(Alpha);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b289539","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-color/src/components/common/Alpha.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vc-alpha"},[_c('div',{staticClass:"vc-alpha-checkboard-wrap"},[_c('checkboard')],1),_vm._v(" "),_c('div',{staticClass:"vc-alpha-gradient",style:({background: _vm.gradientColor})}),_vm._v(" "),_c('div',{ref:"container",staticClass:"vc-alpha-container",on:{"mousedown":_vm.handleMouseDown,"touchmove":_vm.handleChange,"touchstart":_vm.handleChange}},[_c('div',{staticClass:"vc-alpha-pointer",style:({left: _vm.colors.a * 100 + '%'})},[_c('div',{staticClass:"vc-alpha-picker"})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var common_Alpha = (esExports);
// CONCATENATED MODULE: ./node_modules/vue-color/src/components/common/Alpha.vue
function injectStyle (ssrContext) {
  __webpack_require__("Rouy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Alpha_default.a,
  common_Alpha,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_common_Alpha = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "jpKL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue-color/src/components/common/EditableInput.vue
var EditableInput = __webpack_require__("XuJW");
var EditableInput_default = /*#__PURE__*/__webpack_require__.n(EditableInput);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-89c8e946","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-color/src/components/common/EditableInput.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vc-editable-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.val),expression:"val"}],ref:"input",staticClass:"vc-input__input",domProps:{"value":(_vm.val)},on:{"keydown":_vm.handleKeyDown,"input":[function($event){if($event.target.composing){ return; }_vm.val=$event.target.value},_vm.update]}}),_vm._v(" "),_c('span',{staticClass:"vc-input__label"},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('span',{staticClass:"vc-input__desc"},[_vm._v(_vm._s(_vm.desc))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var common_EditableInput = (esExports);
// CONCATENATED MODULE: ./node_modules/vue-color/src/components/common/EditableInput.vue
function injectStyle (ssrContext) {
  __webpack_require__("yeXv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  EditableInput_default.a,
  common_EditableInput,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_common_EditableInput = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "kYuG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lKIo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue-color/src/components/common/Checkboard.vue
var Checkboard = __webpack_require__("9Giv");
var Checkboard_default = /*#__PURE__*/__webpack_require__.n(Checkboard);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3232115a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-color/src/components/common/Checkboard.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vc-checkerboard",style:(_vm.bgStyle)})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var common_Checkboard = (esExports);
// CONCATENATED MODULE: ./node_modules/vue-color/src/components/common/Checkboard.vue
function injectStyle (ssrContext) {
  __webpack_require__("DM9A")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Checkboard_default.a,
  common_Checkboard,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_common_Checkboard = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "lwEJ":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIwLjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiCgkgdmlld0JveD0iMCAwIDI2IDIwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAyNiAyMDsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPgoJLnN0MHtmaWxsOiNFMjMzMzc7fQoJLnN0MXtmaWxsOiNCNjMwMzI7fQo8L3N0eWxlPgo8ZyBpZD0i44Os44Kk44Ok44O8XzEiPgoJPGc+CgkJPHBhdGggY2xhc3M9InN0MCIgZD0iTTQsMy4xbDEuNCwxMS43TDEzLDE5di03LjRoLTIuNGwtMS4xLDIuOGwtMi4xLDBMMTMsMi4xbDAsMFYwTDQsMy4xeiIvPgoJCTxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik0xMyw5LjlWNmwtMS42LDMuOUgxM3oiLz4KCTwvZz4KCTxnPgoJCTxwYXRoIGNsYXNzPSJzdDEiIGQ9Ik0xMywwdjIuMWwwLDBsNS41LDEyLjNsLTIuMSwwbC0xLjEtMi44SDEzVjE5bDcuNi00LjFMMjIsMy4xTDEzLDB6Ii8+CgkJPHBhdGggY2xhc3M9InN0MSIgZD0iTTE0LjYsOS45TDEzLDZ2My45SDE0LjZ6Ii8+Cgk8L2c+CjwvZz4KPGcgaWQ9Il94MzFfb3V0bGluZWQiPgoJPGc+CgkJPHBhdGggY2xhc3M9InN0MSIgZD0iTTIzLjgsMTJIMjV2N2gtMS40di01LjRsLTEuMiwxbC0wLjctMC45TDIzLjgsMTJ6Ii8+Cgk8L2c+CjwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ "mca8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oEYF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue-color/src/components/common/Hue.vue
var Hue = __webpack_require__("5gQg");
var Hue_default = /*#__PURE__*/__webpack_require__.n(Hue);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d7300c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-color/src/components/common/Hue.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['vc-hue', _vm.directionClass]},[_c('div',{ref:"container",staticClass:"vc-hue-container",on:{"mousedown":_vm.handleMouseDown,"touchmove":_vm.handleChange,"touchstart":_vm.handleChange}},[_c('div',{staticClass:"vc-hue-pointer",style:({top: _vm.pointerTop, left: _vm.pointerLeft})},[_c('div',{staticClass:"vc-hue-picker"})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var common_Hue = (esExports);
// CONCATENATED MODULE: ./node_modules/vue-color/src/components/common/Hue.vue
function injectStyle (ssrContext) {
  __webpack_require__("D7tP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Hue_default.a,
  common_Hue,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_common_Hue = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "oFtk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _color = __webpack_require__("f1Ea");

var _color2 = _interopRequireDefault(_color);

var _EditableInput = __webpack_require__("jpKL");

var _EditableInput2 = _interopRequireDefault(_EditableInput);

var _Saturation = __webpack_require__("54sa");

var _Saturation2 = _interopRequireDefault(_Saturation);

var _Hue = __webpack_require__("oEYF");

var _Hue2 = _interopRequireDefault(_Hue);

var _Alpha = __webpack_require__("fM5p");

var _Alpha2 = _interopRequireDefault(_Alpha);

var _Checkboard = __webpack_require__("lKIo");

var _Checkboard2 = _interopRequireDefault(_Checkboard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Chrome',
  mixins: [_color2.default],
  props: {
    disableAlpha: {
      type: Boolean,
      default: false
    },
    disableFields: {
      type: Boolean,
      default: false
    }
  },
  components: {
    saturation: _Saturation2.default,
    hue: _Hue2.default,
    alpha: _Alpha2.default,
    'ed-in': _EditableInput2.default,
    checkboard: _Checkboard2.default
  },
  data: function data() {
    return {
      fields: ['hex', 'rgba', 'hsla'],
      fieldsIndex: 0,
      highlight: false
    };
  },

  computed: {
    hsl: function hsl() {
      var _colors$hsl = this.colors.hsl,
          h = _colors$hsl.h,
          s = _colors$hsl.s,
          l = _colors$hsl.l;

      return {
        h: h.toFixed(),
        s: (s * 100).toFixed() + '%',
        l: (l * 100).toFixed() + '%'
      };
    },
    activeColor: function activeColor() {
      var rgba = this.colors.rgba;
      return 'rgba(' + [rgba.r, rgba.g, rgba.b, rgba.a].join(',') + ')';
    }
  },
  watch: {
    colors: function colors(newVal) {
      var a = newVal.a;

      if (a < 1 && this.fieldsIndex === 0) {
        this.fieldsIndex = 1;
      }
    }
  },
  methods: {
    handlePreset: function handlePreset(c) {
      this.colorChange({
        hex: c,
        source: 'hex'
      });
    },
    childChange: function childChange(data) {
      this.colorChange(data);
    },
    inputChange: function inputChange(data) {
      if (!data) {
        return;
      }
      if (data.hex) {
        this.isValidHex(data.hex) && this.colorChange({
          hex: data.hex,
          source: 'hex'
        });
      } else if (data.r || data.g || data.b || data.a) {
        this.colorChange({
          r: data.r || this.colors.rgba.r,
          g: data.g || this.colors.rgba.g,
          b: data.b || this.colors.rgba.b,
          a: data.a || this.colors.rgba.a,
          source: 'rgba'
        });
      } else if (data.h || data.s || data.l) {
        var s = data.s ? data.s.replace('%', '') / 100 : this.colors.hsl.s;
        var l = data.l ? data.l.replace('%', '') / 100 : this.colors.hsl.l;

        this.colorChange({
          h: data.h || this.colors.hsl.h,
          s: s,
          l: l,
          source: 'hsl'
        });
      }
    },
    toggleViews: function toggleViews() {
      if (this.fieldsIndex >= 2) {
        this.fieldsIndex = this.colors.a < 1 ? 1 : 0;
        return;
      }
      this.fieldsIndex++;
    },
    showHighlight: function showHighlight() {
      this.highlight = true;
    },
    hideHighlight: function hideHighlight() {
      this.highlight = false;
    }
  }
};

/***/ }),

/***/ "q7Qo":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "rSGq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "s9fu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sBxa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ss3p":
/***/ (function(module, exports) {

module.exports = [{"name":"Expandable List","category":"List","elements":"ons-list ons-list-item","markup":"<ul class=\"list\"><li class=\"list-item list-item--expandable expanded\"><div class=\"list-item__top\"><div class=\"list-item__center\">Item</div><div class=\"list-item__right\"><span class=\"list-item__expand-chevron\"></span></div></div><div class=\"list-item__expandable-content\">Expanded content</div></li></ul>","versions":["2.10.0","2.10.1"]},{"name":"Material Action Sheet","category":"Action Sheet","elements":"ons-action-sheet","markup":"<div class=\"action-sheet-mask action-sheet-mask--material\"></div><div class=\"action-sheet action-sheet--material\"><button class=\"action-sheet-button action-sheet-button--material\"><i class=\"ion-ios-square action-sheet-icon--material\"></i>Label</button><button class=\"action-sheet-button action-sheet-button--material\"><i class=\"ion-ios-square action-sheet-icon--material\"></i>Label</button><button class=\"action-sheet-button action-sheet-button--material\"><i class=\"ion-ios-close action-sheet-icon--material\"></i>Cancel</button></div>","versions":["2.10.10"],"replace":true},{"name":"Material Action Sheet with Title","category":"Action Sheet","elements":"ons-action-sheet","markup":"<div class=\"action-sheet-mask action-sheet-mask--material\"></div><div class=\"action-sheet action-sheet--material\"><div class=\"action-sheet-title action-sheet-title--material\">Title</div><button class=\"action-sheet-button action-sheet-button--material\"><i class=\"ion-ios-square action-sheet-icon--material\"></i>Label</button><button class=\"action-sheet-button action-sheet-button--material\"><i class=\"ion-ios-close action-sheet-icon--material\"></i>Cancel</button></div>","versions":["2.10.10"],"replace":true},{"name":"Icon Only Tabbar","category":"Tabbar","elements":"ons-tabbar ons-tab","markup":"<div class=\"tabbar\"><label class=\"tabbar__item\"><input type=\"radio\" name=\"tabbar-b\" checked=\"checked\"><button class=\"tabbar__button\"><i class=\"tabbar__icon ion-ios-square\"></i></button></label><label class=\"tabbar__item\"><input type=\"radio\" name=\"tabbar-b\"><button class=\"tabbar__button\"><i class=\"tabbar__icon ion-ios-radio-button-on\"></i></button></label><label class=\"tabbar__item\"><input type=\"radio\" name=\"tabbar-b\"><button class=\"tabbar__button\"><i class=\"tabbar__icon ion-ios-star\"></i></button></label></div>","versions":["2.10.10"],"replace":true},{"name":"Icon Tabbar","category":"Tabbar","elements":"ons-tabbar ons-tab","markup":"<div class=\"tabbar\"><label class=\"tabbar__item\"><input type=\"radio\" name=\"tabbar-a\" checked=\"checked\"><button class=\"tabbar__button\"><i class=\"tabbar__icon ion-ios-square\"></i><div class=\"tabbar__label\">One</div></button></label><label class=\"tabbar__item\"><input type=\"radio\" name=\"tabbar-a\"><button class=\"tabbar__button\"><i class=\"tabbar__icon ion-ios-radio-button-on\"></i><div class=\"tabbar__label\">Two</div></button></label><label class=\"tabbar__item\"><input type=\"radio\" name=\"tabbar-a\"><button class=\"tabbar__button\"><i class=\"tabbar__icon ion-ios-star\"></i><div class=\"tabbar__label\">Three</div></button></label></div>","versions":["2.10.10"],"replace":true},{"name":"Top Tabbar","category":"Tabbar","elements":"ons-tabbar ons-tab","markup":"<div class=\"tabbar tabbar--top\"><label class=\"tabbar__item\"><input type=\"radio\" name=\"top-tabbar-a\" checked=\"checked\"><button class=\"tabbar__button\"><i class=\"tabbar__icon ion-ios-square\"></i></button></label><label class=\"tabbar__item\"><input type=\"radio\" name=\"top-tabbar-a\"><button class=\"tabbar__button\"><i class=\"tabbar__icon ion-ios-radio-button-on\"></i></button></label><label class=\"tabbar__item\"><input type=\"radio\" name=\"top-tabbar-a\"><button class=\"tabbar__button\"><i class=\"tabbar__icon ion-ios-star\"></i></button></label></div>","versions":["2.10.10"],"replace":true},{"name":"Toolbar Item","category":"Toolbar","elements":"ons-toolbar ons-toolbar-button","markup":"<div class=\"toolbar\"><div class=\"toolbar__left\"><span class=\"toolbar-button\"><i class=\"ion-ios-menu\" style=\"font-size:32px; vertical-align:-6px;\"></i></span></div><div class=\"toolbar__center\">Navigation Bar</div><div class=\"toolbar__right\"><span class=\"toolbar-button\">Label</span></div></div>","versions":["2.10.10"],"replace":true},{"name":"Toolbar with Outline Button","category":"Toolbar","elements":"ons-toolbar ons-toolbar-button","markup":"<div class=\"toolbar\"><div class=\"toolbar__left\"><span class=\"toolbar-button toolbar-button--outline\"><i class=\"ion-ios-menu\" style=\"font-size:32px; vertical-align:-6px;\"></i></span></div><div class=\"toolbar__center\">Title</div><div class=\"toolbar__right\"><span class=\"toolbar-button toolbar-button--outline\">Button</span></div></div>","versions":["2.10.10"],"replace":true}]

/***/ }),

/***/ "tc0q":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIwLjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiCgkgdmlld0JveD0iMCAwIDI2IDIwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAyNiAyMDsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPgoJLnN0MHtmaWxsOiNFMjMzMzc7fQoJLnN0MXtmaWxsOiNCNjMwMzI7fQo8L3N0eWxlPgo8ZyBpZD0i44Os44Kk44Ok44O8XzEiPgoJPGc+CgkJPHBhdGggY2xhc3M9InN0MCIgZD0iTTQsMy4xbDEuNCwxMS43TDEzLDE5di03LjRoLTIuNGwtMS4xLDIuOGwtMi4xLDBMMTMsMi4xbDAsMFYwTDQsMy4xeiIvPgoJCTxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik0xMyw5LjlWNmwtMS42LDMuOUgxM3oiLz4KCTwvZz4KCTxnPgoJCTxwYXRoIGNsYXNzPSJzdDEiIGQ9Ik0xMywwdjIuMWwwLDBsNS41LDEyLjNsLTIuMSwwbC0xLjEtMi44SDEzVjE5bDcuNi00LjFMMjIsMy4xTDEzLDB6Ii8+CgkJPHBhdGggY2xhc3M9InN0MSIgZD0iTTE0LjYsOS45TDEzLDZ2My45SDE0LjZ6Ii8+Cgk8L2c+CjwvZz4KPGcgaWQ9Il94MzJfX291dGxpbmVkIj4KCTxnPgoJCTxwYXRoIGNsYXNzPSJzdDEiIGQ9Ik0yMS40LDE5di0xLjJjMC42LTAuNiwzLTIuNiwzLTMuOWMwLTAuNi0wLjYtMC45LTEuMS0wLjljLTAuNiwwLTEuMSwwLjMtMS42LDAuNmwtMC4xLTEuMgoJCQljMC42LTAuMywxLjQtMC41LDIuMS0wLjVjMS4zLDAsMi4yLDAuNywyLjIsMmMwLDEuNS0xLjUsMi44LTIuNiw0SDI2VjE5SDIxLjR6Ii8+Cgk8L2c+CjwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ "vhUl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wpRs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yeXv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yuGJ":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"version":"Version","theme":"Theme Preset","platforms":"Platforms","categories":"Categories","customize":"Customize"},"ja":{"version":"バージョン","theme":"テーマプリセット","platforms":"プラットフォーム","categories":"カテゴリー","customize":"カスタマイズ"}}')
}


/***/ }),

/***/ "zkob":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 1792 1792\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M491 1536l91-91-235-235-91 91v107h128v128h107zm523-928q0-22-22-22-10 0-17 7l-542 542q-7 7-7 17 0 22 22 22 10 0 17-7l542-542q7-7 7-17zm-54-192l416 416-832 832h-416v-416zm683 96q0 53-37 90l-166 166-416-416 166-165q36-38 90-38 53 0 91 38l235 234q37 39 37 91z\" fill=\"#fff\"></path></svg>"

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.4ff4973bafdfba1bc980.js